package features.booking

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import kotlin.time.Clock
import org.example.abigail.formatMillisToDate
import org.example.abigail.abrirVistaPreviaRuta
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Dashboard
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Map
import androidx.compose.material.icons.filled.ExitToApp
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material.icons.filled.EmojiEvents
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.People
import org.jetbrains.compose.resources.painterResource
import androidx.compose.foundation.Image
import abi.composeapp.generated.resources.Res
import abi.composeapp.generated.resources.logotipo_smartvan
import androidx.compose.foundation.shape.CircleShape
import kotlinx.coroutines.flow.first
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.material.icons.filled.AccountCircle
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.CalendarToday
import androidx.compose.material.icons.filled.Cancel
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Key
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.PersonAdd
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.Timer
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material.icons.filled.DirectionsBus
import androidx.compose.material.icons.filled.MonitorHeart
import androidx.compose.material.icons.filled.Payments
import androidx.compose.material.icons.filled.LocationCity
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.AttachMoney
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Place
import androidx.compose.material.icons.filled.ArrowForward
import androidx.compose.material.icons.filled.ConfirmationNumber
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.TripOrigin
import androidx.compose.material.icons.filled.EventSeat
import androidx.compose.material.icons.filled.MoneyOff
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.HourglassEmpty
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.FileDownload
import androidx.compose.material.icons.filled.Receipt
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.ui.unit.sp
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import kotlinx.coroutines.delay
import androidx.compose.ui.platform.LocalUriHandler
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.statement.bodyAsText

// Refactor parcial aplicado. Extraídos a archivos propios:
// - SolicitudesFacturaView + FacturaCard → SolicitudesFacturaScreen.kt
// - GestionBoletosView → GestionBoletosScreen.kt
// - ReservaEfectivoView → ReservaEfectivoScreen.kt
// - HistorialPagosView + PagoCard → HistorialPagosScreen.kt
// - EditorRutasMapa → EditorRutasMapaScreen.kt
// - ConfiguradorAsientos + MapaAsientosDinamico → ConfiguradorAsientosScreen.kt
// Pendientes de extraer (siguen aquí):
// - ReservaCard + DialogoReprogramacion + ConflictoAsientoCard

/** Burbujita roja con contador para items del drawer que requieren atención (pendientes). */
@Composable
private fun RowScope.DrawerBadge(count: Int) {
    if (count <= 0) return
    Spacer(modifier = Modifier.weight(1f))
    Box(
        modifier = Modifier
            .defaultMinSize(minWidth = 20.dp, minHeight = 20.dp)
            .background(Color(0xFFD32F2F), CircleShape)
            .padding(horizontal = 6.dp, vertical = 2.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            if (count > 99) "99+" else count.toString(),
            color = Color.White, fontSize = 11.sp, fontWeight = FontWeight.Bold
        )
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AdminScreen(viewModel: AdminViewModel, notificacionViewModel: NotificacionViewModel, onNavigateToClient: () -> Unit, onLogout: () -> Unit, onVerPanelChofer: (uid: String, nombre: String) -> Unit = { _, _ -> }) {
    val drawerState = rememberDrawerState(initialValue = DrawerValue.Closed)
    val scope = rememberCoroutineScope()
    var currentScreen by remember { mutableStateOf("Dashboard") }
    // Modo espectador de chofer: dialog para seleccionar a qué chofer ver como.
    var mostrarDialogVerChofer by remember { mutableStateOf(false) }
    val listaUsuarios by viewModel.usuariosRegistrados.collectAsState()
    var nombreUsuario by remember { mutableStateOf("Cargando...") }
    var rolUsuario by remember { mutableStateOf("ADMINISTRADOR") }
    var rolInterno by remember { mutableStateOf("admin") }

    LaunchedEffect(Unit) {
        val user = Firebase.auth.currentUser
        if (user != null) {
            notificacionViewModel.cargarNotificaciones(user.uid, rolInterno)
            viewModel.cargarBadgesPendientes()
            try {
                val db = network.FirebaseClient.database
                val snapshot = db.reference("usuarios/${user.uid}").valueEvents.first()
                val datos = snapshot.value<Map<String, String>>()

                if (datos != null) {
                    nombreUsuario = datos["nombre"] ?: datos["nombre:"] ?: "Usuario"

                    val rolRaw = datos["rol"] ?: "administrador"
                    rolInterno = rolRaw
                    rolUsuario = "ADMINISTRADOR"
                }
            } catch (e: Exception) {
                nombreUsuario = user.email ?: "Usuario"
            }
        }
    }

    // Refrescar las burbujitas de pendientes cada vez que se abre el drawer.
    LaunchedEffect(drawerState.isOpen) {
        if (drawerState.isOpen) viewModel.cargarBadgesPendientes()
    }
    ModalNavigationDrawer(
        drawerState = drawerState,
        drawerContent = {
            ModalDrawerSheet(
                modifier = Modifier.width(300.dp),
                drawerContainerColor = Color.White
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(rememberScrollState()),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(SmartVanColors.AzulOscuro),
                        contentAlignment = Alignment.BottomStart
                    ) {
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 24.dp, vertical = 32.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Box(
                                modifier = Modifier
                                    .padding(bottom = 16.dp)
                                    .background(Color.White, shape = CircleShape)
                                    .padding(12.dp)
                            ) {
                                Image(
                                    painter = painterResource(Res.drawable.logotipo_smartvan),
                                    contentDescription = "Logotipo SMARTVAN",
                                    modifier = Modifier.size(height = 100.dp, width = 160.dp),
                                    colorFilter = null
                                )
                            }

                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "Bienvenido,",
                                color = Color.White,
                                style = MaterialTheme.typography.titleMedium,
                                textAlign = TextAlign.Center
                            )
                            Text(
                                text = rolUsuario,
                                color = Color.White,
                                style = MaterialTheme.typography.titleLarge,
                                fontWeight = FontWeight.Bold,
                                textAlign = TextAlign.Center
                            )

                            Spacer(modifier = Modifier.height(8.dp))
                            Text(
                                text = nombreUsuario,
                                color = Color(0xFF41B6E6),
                                fontWeight = FontWeight.Black,
                                style = MaterialTheme.typography.headlineSmall,
                                textAlign = TextAlign.Center
                            )

                            Spacer(modifier = Modifier.height(16.dp))
                            HorizontalDivider(color = Color.White.copy(alpha = 0.2f))
                        }
                    }


                    Spacer(modifier = Modifier.height(16.dp))
                    Text(
                        "PANEL DE CONTROL",
                        color = Color.Gray,
                        style = MaterialTheme.typography.labelSmall,
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp)
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Dashboard,
                                    contentDescription = null,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Dashboard e Ingresos")
                            }
                        },
                        selected = currentScreen == "Dashboard",
                        onClick = {
                            currentScreen = "Dashboard"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.DateRange,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Programar Viaje")
                            }
                        },
                        selected = currentScreen == "Programar",
                        onClick = {
                            currentScreen = "Programar"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Settings,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Administrar Datos")

                            }
                        },

                        selected = currentScreen == "Datos",
                        onClick = { currentScreen = "Datos"; scope.launch { drawerState.close() } },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.DirectionsBus,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Vista de Choferes")
                            }
                        },
                        selected = false,
                        onClick = {
                            mostrarDialogVerChofer = true
                            scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(0xFFE0F7FA),
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    if (rolInterno == "desarrollador" || rolInterno == "admin_general" || rolInterno == "master" || rolInterno == "admin") {
                        NavigationDrawerItem(
                            label = {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(
                                        Icons.Filled.AttachMoney,
                                        contentDescription = null,
                                        tint = Color.Gray,
                                        modifier = Modifier.padding(end = 12.dp)
                                    )
                                    Text("Precios y Tarifas")
                                }
                            },
                            selected = currentScreen == "Precios",
                            onClick = { currentScreen = "Precios"; scope.launch { drawerState.close() } },
                            modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                            colors = NavigationDrawerItemDefaults.colors(
                                selectedContainerColor = Color(
                                    0xFFE0F7FA
                                ), selectedTextColor = SmartVanColors.AzulOscuro
                            )
                        )
                    }
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.People,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Administrar Cuentas")
                            }
                        },
                        selected = currentScreen == "Cuentas",
                        onClick = {
                            currentScreen = "Cuentas"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.CyanAccent
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Map,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Viajes Publicados")
                            }
                        },
                        selected = currentScreen == "Publicados",
                        onClick = {
                            currentScreen = "Publicados"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.MoneyOff,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Reservar en Efectivo")
                            }
                        },
                        selected = currentScreen == "ReservaEfectivo",
                        onClick = {
                            currentScreen = "ReservaEfectivo"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                            label = {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(
                                        Icons.Filled.Email,
                                        contentDescription = null,
                                        tint = Color.Gray,
                                        modifier = Modifier.padding(end = 12.dp)
                                    )
                                    Text("Gestion de Boletos")
                                }
                            },
                        selected = currentScreen == "gestion_boletos",
                        onClick = {
                            currentScreen = "gestion_boletos"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = Color(
                                0xFFE0F7FA
                            ), selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Receipt,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Historial de Pagos")
                            }
                        },
                        selected = currentScreen == "historial_pagos",
                        onClick = {
                            currentScreen = "historial_pagos"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Receipt,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Solicitudes de Factura")
                                val badgeFac by viewModel.badgeFacturas.collectAsState()
                                DrawerBadge(badgeFac)
                            }
                        },
                        selected = currentScreen == "facturas",
                        onClick = {
                            currentScreen = "facturas"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(Icons.Filled.Settings, contentDescription = null, tint = Color.Gray, modifier = Modifier.padding(end = 12.dp))
                                Text("Config. Pagos")
                                val stripeOn by viewModel.stripeActivo.collectAsState()
                                val badgePM by viewModel.badgePagosManuales.collectAsState()
                                Spacer(modifier = Modifier.weight(1f))
                                if (badgePM > 0) {
                                    // Pagos manuales por confirmar — burbuja roja con contador.
                                    Box(
                                        modifier = Modifier
                                            .defaultMinSize(minWidth = 20.dp, minHeight = 20.dp)
                                            .background(Color(0xFFD32F2F), CircleShape)
                                            .padding(horizontal = 6.dp, vertical = 2.dp),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        Text(if (badgePM > 99) "99+" else badgePM.toString(), color = Color.White, fontSize = 11.sp, fontWeight = FontWeight.Bold)
                                    }
                                    Spacer(modifier = Modifier.width(6.dp))
                                }
                                Box(
                                    modifier = Modifier
                                        .size(8.dp)
                                        .background(if (stripeOn) SmartVanColors.Verde else SmartVanColors.Naranja, CircleShape)
                                )
                            }
                        },
                        selected = currentScreen == "config_pagos",
                        onClick = { currentScreen = "config_pagos"; scope.launch { drawerState.close() } },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(Icons.Filled.Receipt, contentDescription = null, tint = Color.Gray, modifier = Modifier.padding(end = 12.dp))
                                Text("Auditoría")
                            }
                        },
                        selected = currentScreen == "auditoria",
                        onClick = { currentScreen = "auditoria"; scope.launch { drawerState.close() } },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(Icons.Filled.MoneyOff, contentDescription = null, tint = Color.Gray, modifier = Modifier.padding(end = 12.dp))
                                Text("Cancelaciones")
                                val badgeCanc by viewModel.badgeCancelaciones.collectAsState()
                                DrawerBadge(badgeCanc)
                            }
                        },
                        selected = currentScreen == "cancelaciones",
                        onClick = { currentScreen = "cancelaciones"; scope.launch { drawerState.close() } },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                Icon(
                                    Icons.Filled.Notifications,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Notificaciones")
                                val noLeidasDrawer by notificacionViewModel.noLeidas.collectAsState()
                                if (noLeidasDrawer > 0) {
                                    Spacer(modifier = Modifier.weight(1f))
                                    Badge(containerColor = Color.Red) {
                                        Text("$noLeidasDrawer", color = Color.White, fontSize = 10.sp)
                                    }
                                }
                            }
                        },
                        selected = currentScreen == "Notificaciones",
                        onClick = {
                            currentScreen = "Notificaciones"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.FondoCyan,
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.Map,
                                    contentDescription = null,
                                    tint = if (currentScreen == "RutasMapa") SmartVanColors.CyanAccent else Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Rutas en Mapa")
                            }
                        },
                        selected = currentScreen == "RutasMapa",
                        onClick = {
                            currentScreen = "RutasMapa"; scope.launch { drawerState.close() }
                        },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(
                            selectedContainerColor = SmartVanColors.CyanAccent.copy(alpha = 0.1f),
                            selectedTextColor = SmartVanColors.AzulOscuro
                        )
                    )

                    // Solo desarrollador: diagnóstico de APIs (SendGrid, Stripe, RTDB, etc.)
                    if (rolInterno == "desarrollador") {
                        NavigationDrawerItem(
                            label = {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(
                                        Icons.Filled.MonitorHeart,
                                        contentDescription = null,
                                        tint = if (currentScreen == "diagnostico") SmartVanColors.CyanAccent else Color.Gray,
                                        modifier = Modifier.padding(end = 12.dp)
                                    )
                                    Text("Diagnóstico Sistema")
                                }
                            },
                            selected = currentScreen == "diagnostico",
                            onClick = { currentScreen = "diagnostico"; scope.launch { drawerState.close() } },
                            modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                            colors = NavigationDrawerItemDefaults.colors(
                                selectedContainerColor = SmartVanColors.CyanAccent.copy(alpha = 0.1f),
                                selectedTextColor = SmartVanColors.AzulOscuro
                            )
                        )
                    }

                    Spacer(modifier = Modifier.weight(1f))
                    HorizontalDivider()
                    Text(
                        "SISTEMA",
                        color = Color.Gray,
                        style = MaterialTheme.typography.labelSmall,
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp)
                    )

                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.AccountCircle,
                                    contentDescription = null,
                                    tint = Color.Gray,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Ver App como Cliente")
                            }
                        },
                        selected = false,
                        onClick = { onNavigateToClient() },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp)
                    )
                    NavigationDrawerItem(
                        label = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    Icons.Filled.ExitToApp,
                                    contentDescription = null,
                                    tint = Color.Red,
                                    modifier = Modifier.padding(end = 12.dp)
                                )
                                Text("Cerrar Sesión", color = Color.Red)
                            }
                        },
                        selected = false,
                        onClick = { onLogout() },
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 4.dp),
                        colors = NavigationDrawerItemDefaults.colors(unselectedTextColor = Color.Red)
                    )
                    Spacer(modifier = Modifier.height(16.dp))
                }
            }
        }
    ) {
        Scaffold(
            topBar = {
                TopAppBar(
                    title = {
                        Text(
                            if (currentScreen == "Dashboard") "SMARTVAN Admin" else currentScreen,
                            fontWeight = FontWeight.Bold,
                            color = Color.White
                        )
                    },
                    navigationIcon = {
                        IconButton(onClick = { scope.launch { drawerState.open() } }) {
                            Icon(Icons.Filled.Menu, contentDescription = "Menú", tint = Color.White)
                        }
                    },
                    actions = {
                        IconButton(onClick = { currentScreen = "Notificaciones" }) {
                            BadgedBox(badge = {
                                val noLeidas by notificacionViewModel.noLeidas.collectAsState()
                                if (noLeidas > 0) {
                                    Badge(containerColor = Color.Red) {
                                        Text("$noLeidas", color = Color.White, fontSize = 10.sp)
                                    }
                                }
                            }) {
                                Icon(Icons.Filled.Notifications, contentDescription = "Notificaciones", tint = Color.White)
                            }
                        }
                    },
                    colors = TopAppBarDefaults.topAppBarColors(containerColor = SmartVanColors.AzulOscuro)
                )
            }
        ) { paddingValues ->
            Box(modifier = Modifier.padding(paddingValues).fillMaxSize()) {
                when (currentScreen) {
                    "Dashboard" -> {
                        var showStartPicker by remember { mutableStateOf(false) }
                        var showEndPicker by remember { mutableStateOf(false) }
                        val startState = rememberDatePickerState()
                        val endState = rememberDatePickerState()

                        val inicio by viewModel.fechaDesde.collectAsState()
                        val fin by viewModel.fechaHasta.collectAsState()

                        DashboardConReportesView(
                            viewModel = viewModel,
                            inicio = inicio,
                            fin = fin,
                            onOpenStart = { showStartPicker = true },
                            onOpenEnd = { showEndPicker = true }
                        )
                        if (showStartPicker) {
                            DatePickerDialog(
                                onDismissRequest = { showStartPicker = false },
                                confirmButton = {
                                    TextButton(onClick = {
                                        startState.selectedDateMillis?.let {
                                            viewModel.actualizarRango(
                                                org.example.abigail.formatMillisToDate(it),
                                                fin
                                            )
                                        }
                                        showStartPicker = false
                                    }) { Text("Confirmar") }
                                }) { DatePicker(state = startState, showModeToggle = false) }
                        }
                        if (showEndPicker) {
                            DatePickerDialog(
                                onDismissRequest = { showEndPicker = false },
                                confirmButton = {
                                    TextButton(onClick = {
                                        endState.selectedDateMillis?.let {
                                            viewModel.actualizarRango(
                                                inicio,
                                                org.example.abigail.formatMillisToDate(it)
                                            )
                                        }
                                        showEndPicker = false
                                    }) { Text("Confirmar") }
                                }) { DatePicker(state = endState, showModeToggle = false) }
                        }
                    }

                    "Programar" -> {
                        CreateTripView(viewModel)
                    }

                    "Datos" -> {
                        ManagedDataView(viewModel)
                    }

                    "Publicados" -> {
                        ViajesPublicadosView(viewModel)
                    }

                    "Precios" -> {
                        PreciosYTarifasView(viewModel)
                    }
                    "Cuentas" -> {
                        AdministrarCuentasView(viewModel, rolInterno)
                    }
                    "ReservaEfectivo" -> {
                        ReservaEfectivoView(viewModel = viewModel)
                    }
                    "gestion_boletos" -> {
                        GestionBoletosView(viewModel = viewModel)
                    }
                    "historial_pagos" -> {
                        HistorialPagosView(viewModel = viewModel)
                    }
                    "facturas" -> {
                        SolicitudesFacturaView(viewModel = viewModel)
                    }
                    "config_pagos" -> {
                        ConfigPagosView(viewModel = viewModel, miRolActual = rolInterno)
                    }
                    "auditoria" -> {
                        AuditoriaView(viewModel = viewModel)
                    }
                    "cancelaciones" -> {
                        CancelacionesView(viewModel = viewModel)
                    }
                    "diagnostico" -> {
                        // Solo desarrollador: si otro rol llegó aquí, redirigir.
                        if (rolInterno == "desarrollador") {
                            DiagnosticoSistemaView(viewModel = viewModel)
                        } else {
                            currentScreen = "Dashboard"
                        }
                    }
                    "Notificaciones" -> {
                        BandejaNotificaciones(
                            viewModel = notificacionViewModel,
                            miUid = dev.gitlive.firebase.Firebase.auth.currentUser?.uid ?: "",
                            onCerrar = { currentScreen = "Dashboard" },
                            onIrA = { destino -> currentScreen = destino }
                        )
                    }
                    "RutasMapa" -> {
                        val ciudades by viewModel.ciudades.collectAsState()
                        val paradasInfoLista by viewModel.paradasInfo.collectAsState()
                        val puntosSubidaInfoLista by viewModel.puntosSubidaInfo.collectAsState()
                        EditorRutasMapa(
                            ciudadesDisponibles = ciudades,
                            paradasInfoDisponibles = paradasInfoLista,
                            puntosSubidaInfoDisponibles = puntosSubidaInfoLista
                        )
                    }
                }

                // Global feedback dialog
                val mensajeGlobal by viewModel.mensajeGlobal.collectAsState()
                mensajeGlobal?.let { msg ->
                    AlertDialog(
                        onDismissRequest = { viewModel.limpiarMensajeGlobal() },
                        title = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                val esError = msg.contains("Error", ignoreCase = true)
                                Icon(
                                    if (esError) Icons.Filled.Warning else Icons.Filled.EmojiEvents,
                                    contentDescription = null,
                                    tint = if (esError) Color.Red else SmartVanColors.Verde,
                                    modifier = Modifier.size(22.dp)
                                )
                                Spacer(modifier = Modifier.width(8.dp))
                                Text(
                                    if (esError) "Aviso" else "Operación Exitosa",
                                    fontWeight = FontWeight.Bold,
                                    color = SmartVanColors.AzulOscuro
                                )
                            }
                        },
                        text = { Text(msg) },
                        confirmButton = {
                            Button(
                                onClick = { viewModel.limpiarMensajeGlobal() },
                                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)
                            ) { Text("Entendido") }
                        }
                    )
                }
            }
        }
    }

    // Dialog para elegir a qué chofer entrar como espectador.
    if (mostrarDialogVerChofer) {
        val choferes = listaUsuarios.filter { it.rol == "chofer" || it.rol == "chofer_admin" }
        AlertDialog(
            onDismissRequest = { mostrarDialogVerChofer = false },
            icon = { Icon(Icons.Filled.DirectionsBus, contentDescription = null, tint = SmartVanColors.AzulOscuro) },
            title = { Text("Ver panel de chofer") },
            text = {
                Column {
                    Text(
                        "Entrarás en modo espectador: verás sus viajes y pasajeros pero no podrás iniciar/finalizar viaje ni marcar asistencia.",
                        style = MaterialTheme.typography.bodySmall, color = Color.Gray
                    )
                    Spacer(modifier = Modifier.height(10.dp))
                    if (choferes.isEmpty()) {
                        Text("No hay choferes registrados.", color = Color.Gray, fontStyle = FontStyle.Italic)
                    } else {
                        LazyColumn(
                            modifier = Modifier.heightIn(max = 320.dp),
                            verticalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            items(choferes) { c ->
                                Card(
                                    colors = CardDefaults.cardColors(containerColor = Color(0xFFF5F7FA)),
                                    shape = RoundedCornerShape(10.dp),
                                    modifier = Modifier.fillMaxWidth().clickable {
                                        mostrarDialogVerChofer = false
                                        onVerPanelChofer(c.uid, c.nombre)
                                    }
                                ) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth().padding(12.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Icon(Icons.Filled.Person, contentDescription = null, tint = SmartVanColors.AzulOscuro, modifier = Modifier.size(20.dp))
                                        Spacer(modifier = Modifier.width(8.dp))
                                        Column(modifier = Modifier.weight(1f)) {
                                            Text(c.nombre.ifBlank { "(sin nombre)" }, fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro)
                                            Text(c.correo, color = Color.Gray, style = MaterialTheme.typography.labelSmall)
                                        }
                                        Text(c.rol, color = Color.Gray, style = MaterialTheme.typography.labelSmall)
                                    }
                                }
                            }
                        }
                    }
                }
            },
            confirmButton = {},
            dismissButton = { TextButton(onClick = { mostrarDialogVerChofer = false }) { Text("Cerrar", color = Color.Gray) } }
        )
    }
}

@Composable
fun DashboardConReportesView(viewModel: AdminViewModel, inicio: String, fin: String, onOpenStart: () -> Unit, onOpenEnd: () -> Unit) {
    val bookings by viewModel.bookings.collectAsState()
    val ingresosRango by viewModel.ingresosSemana.collectAsState()
    val ingresosMes by viewModel.ingresosMes.collectAsState()
    val ingresosPendientes by viewModel.ingresosPendientes.collectAsState()
    val boletosVendidos by viewModel.boletosVendidos.collectAsState()
    val rutaEstrella by viewModel.rutaMasPopular.collectAsState()
    val alertas by viewModel.alertas.collectAsState()

    LazyColumn(
        modifier = Modifier.fillMaxSize().padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        // Refresh button
        item {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                TextButton(onClick = { viewModel.cargarEstadisticasGlobales() }) {
                    Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(4.dp))
                    Text("Actualizar datos", color = SmartVanColors.CyanAccent, fontSize = 12.sp)
                }
            }
        }

        // Alertas
        if (alertas.isNotEmpty()) {
            item {
                Text("Actividad Reciente", fontWeight = FontWeight.Black, modifier = Modifier.padding(bottom = 4.dp))
            }
            items(alertas.size) { index ->
                val alerta = alertas[index]
                Card(
                    colors = CardDefaults.cardColors(containerColor = Color.White),
                    elevation = CardDefaults.cardElevation(defaultElevation = 1.dp),
                    shape = RoundedCornerShape(14.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(modifier = Modifier.fillMaxWidth().padding(14.dp), verticalAlignment = Alignment.CenterVertically) {
                        val alertIcon = when (alerta.icono) {
                            "TICKET" -> Icons.Filled.Email
                            "ALERTA" -> Icons.Filled.Warning
                            else -> Icons.Filled.Notifications
                        }
                        Box(
                            modifier = Modifier
                                .size(40.dp)
                                .background(alerta.color.copy(alpha = 0.1f), CircleShape),
                            contentAlignment = Alignment.Center
                        ) {
                            Icon(alertIcon, contentDescription = null, tint = alerta.color, modifier = Modifier.size(22.dp))
                        }
                        Spacer(modifier = Modifier.width(12.dp))
                        Column {
                            Text(alerta.titulo, fontWeight = FontWeight.Bold, color = alerta.color, style = MaterialTheme.typography.labelMedium)
                            Text(alerta.descripcion, style = MaterialTheme.typography.bodySmall, color = Color.DarkGray)
                        }
                    }
                }
            }
            item { Spacer(modifier = Modifier.height(16.dp)) }
        }

        // Rango de fechas
        item {
            Text("Filtrar Rango de Fechas", fontWeight = FontWeight.Bold, modifier = Modifier.padding(bottom = 4.dp))
            Row(modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Card(onClick = onOpenStart, modifier = Modifier.weight(1f), colors = CardDefaults.cardColors(containerColor = Color.White)) {
                    Column(modifier = Modifier.padding(8.dp)) {
                        Text("Desde", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                        Text(inicio, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                    }
                }
                Card(onClick = onOpenEnd, modifier = Modifier.weight(1f), colors = CardDefaults.cardColors(containerColor = Color.White)) {
                    Column(modifier = Modifier.padding(8.dp)) {
                        Text("Hasta", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                        Text(fin, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                    }
                }
            }
        }

        // Cards de ingresos
        item {
            Text("Análisis de Ingresos", fontWeight = FontWeight.Bold, modifier = Modifier.padding(bottom = 4.dp))
            Row(modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                ReportCard(
                    modifier = Modifier.weight(1f),
                    title = "Rango Seleccionado",
                    amount = ingresosRango,
                    color = SmartVanColors.Verde,
                    icon = { Icon(Icons.Filled.DateRange, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(20.dp)) }
                )
                ReportCard(
                    modifier = Modifier.weight(1f),
                    title = "Total Mensual",
                    amount = ingresosMes,
                    color = SmartVanColors.Naranja,
                    icon = { Icon(Icons.Filled.EmojiEvents, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(20.dp)) }
                )
            }
        }

        // Card de boletos vendidos
        item {
            ReportCard(
                modifier = Modifier.fillMaxWidth(),
                title = "Boletos Vendidos (Rango)",
                amount = boletosVendidos,
                color = SmartVanColors.CyanAccent,
                icon = { Icon(Icons.Filled.People, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(20.dp)) },
                suffix = "boletos"
            )
        }

        // Efectivo pendiente de cobro (no cuenta como ingreso confirmado)
        if (ingresosPendientes > 0) {
            item {
                Card(
                    modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoNaranja)
                ) {
                    Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.HourglassEmpty, contentDescription = null, tint = SmartVanColors.NaranjaDeep, modifier = Modifier.size(20.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text("Efectivo pendiente de cobro", style = MaterialTheme.typography.bodyMedium, color = SmartVanColors.NaranjaDeep, fontWeight = FontWeight.Bold)
                        Spacer(modifier = Modifier.weight(1f))
                        Text("$$ingresosPendientes MXN", fontWeight = FontWeight.Black, color = SmartVanColors.NaranjaDeep)
                    }
                }
            }
        }

        // Ruta más rentable
        item {
            Card(
                modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
                colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoNaranja)
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(bottom = 4.dp)) {
                        Icon(Icons.Filled.EmojiEvents, contentDescription = "Trofeo", tint = SmartVanColors.Naranja, modifier = Modifier.padding(end = 8.dp))
                        Text("Ruta más rentable (En este rango)", style = MaterialTheme.typography.labelMedium, color = SmartVanColors.Naranja)
                    }
                    Text(rutaEstrella, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Black, color = Color.DarkGray)
                }
            }
        }

        // Gráfica
        if (bookings.isNotEmpty()) {
            item {
                GraficaIngresosSimple(reservas = bookings)
            }
        }

        // #11: El "Manifiesto Global de Pasajeros" se quitó del dashboard: duplicaba lo que ya
        // muestran Historial de Pagos y Gestión de Boletos. Esos son la fuente única.

        item { Spacer(modifier = Modifier.height(16.dp)) }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CreateTripView(viewModel: AdminViewModel) {
    val scrollState = rememberScrollState()
    val ciudades by viewModel.ciudades.collectAsState()
    val choferes by viewModel.choferes.collectAsState()
    val vehiculos by viewModel.vehiculos.collectAsState()
    val horarios by viewModel.horarios.collectAsState()

    val puntosSubida by viewModel.puntosSubida.collectAsState()
    val puntosSubidaInfo by viewModel.puntosSubidaInfo.collectAsState()

    var origen by remember { mutableStateOf("") }
    var destino by remember { mutableStateOf("") }
    // Multi-selección: un viaje puede pasar por VARIOS puntos recogiendo pasajeros distintos.
    // Se guarda concatenado con "|" y el cliente elige uno al reservar (BookingViewModel:406
    // hace split("|")). El chofer agrupa por puntoSubida propio de cada reserva (per-reserva).
    var puntosSubidaSeleccionados by remember { mutableStateOf<List<String>>(emptyList()) }
    var chofer by remember { mutableStateOf("") }
    var vehiculo by remember { mutableStateOf("") }
    var recurrencia by remember { mutableStateOf("Único") }
    // Cuántas repeticiones para las recurrencias por tipo de día.
    var sabadosACrear by remember { mutableStateOf(4) }
    var semanasACrear by remember { mutableStateOf(1) }
    // Escape para cuando un punto aún no tiene etiqueta de días y no aparece en el filtro.
    var mostrarTodosLosPuntos by remember { mutableStateOf(false) }

    var fechaInicio by remember { mutableStateOf(org.example.abigail.obtenerFechaHoy()) }
    var fechaFin by remember { mutableStateOf("") }
    var showDatePickerInicio by remember { mutableStateOf(false) }
    var showDatePickerFin by remember { mutableStateOf(false) }
    val datePickerStateInicio = rememberDatePickerState(
        initialDisplayMode = androidx.compose.material3.DisplayMode.Picker
    )
    val datePickerStateFin = rememberDatePickerState(
        initialDisplayMode = androidx.compose.material3.DisplayMode.Picker
    )

    // Al elegir una recurrencia por tipo de día, la fecha de inicio se alinea sola:
    // "Sábados" arranca en el próximo sábado, "Entre semana" en el próximo día hábil.
    LaunchedEffect(recurrencia) {
        if (recurrencia == "Sábados" && !esSabado(fechaInicio)) fechaInicio = proximoSabado(fechaInicio)
        if (recurrencia == "Entre semana" && !esEntreSemana(fechaInicio)) fechaInicio = proximoDiaEntreSemana(fechaInicio)
    }

    val fechasPrevistas: List<String> = when (recurrencia) {
        "Sábados" -> sabadosDesde(fechaInicio, sabadosACrear)
        "Entre semana" -> diasEntreSemanaDesde(fechaInicio, semanasACrear)
        else -> emptyList()
    }

    // Tipo de día del viaje que se va a publicar. En blanco = el rango abarca ambos,
    // así que no se filtran los puntos de subida.
    val tipoDiaObjetivo = when (recurrencia) {
        "Sábados" -> TipoDia.SABADO
        "Entre semana" -> TipoDia.SEMANA
        "Único" -> tipoDiaDeFecha(fechaInicio)
        else -> ""
    }

    val leyendaProyeccion = when (recurrencia) {
        "Único" -> "Se publicará un (1) solo viaje exactamente el día: $fechaInicio (${nombreDiaDe(fechaInicio)})."
        "Personalizado" -> if (fechaFin.isNotBlank()) "Se publicarán viajes TODOS LOS DÍAS desde $fechaInicio hasta $fechaFin." else "Selecciona la fecha de fin."
        "Entre semana" -> "Se publicarán ${fechasPrevistas.size} viajes de LUNES A VIERNES ($semanasACrear semana(s)), del ${fechaCorta(fechasPrevistas.firstOrNull() ?: fechaInicio)} al ${fechaCorta(fechasPrevistas.lastOrNull() ?: fechaInicio)}. No se crean sábados ni domingos."
        "Sábados" -> "Se publicarán $sabadosACrear viaje(s), SOLO EN SÁBADO: ${fechasPrevistas.joinToString(" · ") { fechaCorta(it) }}."
        "Semanal" -> "Se publicará este viaje TODOS LOS DÍAS durante 1 semana (7 viajes en total), comenzando el $fechaInicio."
        "Mensual" -> "Se publicará este viaje TODOS LOS DÍAS durante 1 mes completo (30 viajes), comenzando el $fechaInicio."
        "Indefinido" -> "Se publicarán viajes TODOS LOS DÍAS durante 30 días a partir del $fechaInicio. Se renuevan automáticamente."
        else -> ""
    }

    Column(modifier = Modifier.fillMaxSize().padding(16.dp).verticalScroll(scrollState), verticalArrangement = Arrangement.spacedBy(16.dp)) {
        Text("Agendar Nuevo Servicio", style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
        Text("Configura los detalles del viaje a publicar.", color = Color.Gray, style = MaterialTheme.typography.bodySmall)

        // --- Sección: Ruta ---
        Card(colors = CardDefaults.cardColors(containerColor = Color.White), shape = RoundedCornerShape(16.dp)) {
            Column(modifier = Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {

                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(32.dp).background(SmartVanColors.CyanAccent.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.Map, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(18.dp))
                    }
                    Spacer(modifier = Modifier.width(10.dp))
                    Text("Ruta del Viaje", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                }

                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    AdminDropdown("Origen", ciudades, origen, { origen = it; puntosSubidaSeleccionados = emptyList() }, Modifier.weight(1f))
                    AdminDropdown("Destino", ciudades, destino, { destino = it; puntosSubidaSeleccionados = emptyList() }, Modifier.weight(1f))
                }

                // Indicador de vínculo con mapa de ruta
                if (origen.isNotBlank() && destino.isNotBlank() && origen != destino) {
                    val nombreRuta = "$origen - $destino"
                    var tieneMapaRuta by remember(nombreRuta) { mutableStateOf<Boolean?>(null) }
                    LaunchedEffect(nombreRuta) {
                        try {
                            val db = network.FirebaseClient.database
                            val snap = db.reference("catalogos/rutas/$nombreRuta/waypoints").valueEvents.first()
                            tieneMapaRuta = try { snap.exists && snap.children.count() > 0 } catch (_: Exception) { snap.exists }
                        } catch (_: Exception) { tieneMapaRuta = false }
                    }
                    tieneMapaRuta?.let { tiene ->
                        Row(
                            modifier = Modifier.fillMaxWidth().background(
                                if (tiene) Color(0xFFE8F5E9) else SmartVanColors.FondoNaranja,
                                RoundedCornerShape(8.dp)
                            ).padding(horizontal = 12.dp, vertical = 6.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            Icon(
                                if (tiene) Icons.Filled.CheckCircle else Icons.Filled.Info,
                                contentDescription = null,
                                tint = if (tiene) SmartVanColors.Verde else SmartVanColors.NaranjaDark,
                                modifier = Modifier.size(14.dp)
                            )
                            Text(
                                if (tiene) "Ruta con mapa configurado: $nombreRuta" else "Sin mapa — configura en Rutas/Mapa",
                                fontSize = 11.sp,
                                color = if (tiene) SmartVanColors.VerdeOscuro else SmartVanColors.NaranjaDeep
                            )
                        }
                    }
                }

                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Box(modifier = Modifier.weight(1f).clickable { showDatePickerInicio = true }) {
                        OutlinedTextField(
                            value = fechaInicio,
                            onValueChange = {},
                            readOnly = true,
                            enabled = false,
                            label = { Text(when (recurrencia) {
                                "Sábados" -> "Primer sábado"
                                "Entre semana" -> "Primer día (lunes a viernes)"
                                else -> "Fecha Inicio"
                            }) },
                            modifier = Modifier.fillMaxWidth(),
                            colors = OutlinedTextFieldDefaults.colors(
                                disabledTextColor = Color.Black,
                                disabledBorderColor = Color.Gray,
                                disabledLabelColor = Color.Gray
                            ),
                            trailingIcon = { Icon(Icons.Filled.CalendarToday, contentDescription = null, tint = Color.Gray, modifier = Modifier.size(20.dp)) }
                        )
                    }
                    if (recurrencia == "Personalizado") {
                        Box(modifier = Modifier.weight(1f).clickable { showDatePickerFin = true }) {
                            OutlinedTextField(
                                value = fechaFin.ifBlank { "Seleccionar..." },
                                onValueChange = {},
                                readOnly = true,
                                enabled = false,
                                label = { Text("Fecha Fin") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = OutlinedTextFieldDefaults.colors(
                                    disabledTextColor = if (fechaFin.isBlank()) Color.Gray else Color.Black,
                                    disabledBorderColor = Color.Gray,
                                    disabledLabelColor = Color.Gray
                                ),
                                trailingIcon = { Icon(Icons.Filled.CalendarToday, contentDescription = null, tint = Color.Gray, modifier = Modifier.size(20.dp)) }
                            )
                        }
                    }
                }

                // Puntos de Subida — filtrado SOLO por ciudad de ORIGEN (donde sale la van)
                Text("Puntos de Subida (selecciona uno o más):", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                val puntosDeLaCiudad = if (origen.isNotBlank()) {
                    puntosSubidaInfo.filter { punto ->
                        punto.ciudad.contains(origen, ignoreCase = true) || origen.contains(punto.ciudad, ignoreCase = true)
                    }
                } else emptyList()
                // Solo se ofrecen los puntos cuya etiqueta de días corresponde al viaje que
                // se está creando. Los "Todos los días" siempre pasan el filtro.
                val hayFiltroDia = tipoDiaObjetivo.isNotBlank() && !mostrarTodosLosPuntos
                val puntosOrigenFiltrados = if (hayFiltroDia) {
                    puntosDeLaCiudad.filter { puntoAplicaEnTipo(it.dias, tipoDiaObjetivo) }
                } else puntosDeLaCiudad
                // Al cambiar de tipo de día, soltar los puntos que ya no aplican para no
                // publicar un viaje de sábado con la hora de entre semana.
                LaunchedEffect(tipoDiaObjetivo, mostrarTodosLosPuntos, origen) {
                    if (hayFiltroDia) {
                        puntosSubidaSeleccionados = puntosSubidaSeleccionados.filter { nombre ->
                            puntosOrigenFiltrados.any { it.nombre == nombre }
                        }
                    }
                }
                if (tipoDiaObjetivo.isNotBlank()) {
                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                        EtiquetaDias(tipoDiaObjetivo)
                        Text(
                            if (mostrarTodosLosPuntos) "Mostrando todos los puntos de $origen"
                            else "Mostrando los puntos de ${TipoDia.etiqueta(tipoDiaObjetivo).lowercase()}",
                            fontSize = 11.sp, color = Color.Gray, modifier = Modifier.weight(1f)
                        )
                        TextButton(onClick = { mostrarTodosLosPuntos = !mostrarTodosLosPuntos }, contentPadding = PaddingValues(horizontal = 6.dp)) {
                            Text(if (mostrarTodosLosPuntos) "Filtrar" else "Ver todos", fontSize = 11.sp, color = SmartVanColors.Azul)
                        }
                    }
                } else if (origen.isNotBlank()) {
                    Text("Esta recurrencia abarca días entre semana y fines de semana — revisa que los puntos y sus horas apliquen a todos.",
                        fontSize = 11.sp, color = SmartVanColors.NaranjaDeep)
                }
                if (puntosOrigenFiltrados.isEmpty() && origen.isNotBlank()) {
                    Text(
                        if (puntosDeLaCiudad.isNotEmpty())
                            "Ningún punto de $origen está marcado como \"${TipoDia.etiqueta(tipoDiaObjetivo)}\". Etiquétalos en Catálogos → Puntos de Subida, o toca \"Ver todos\"."
                        else "No hay puntos de subida para $origen. Agrégalos en Catálogos → Puntos de Subida.",
                        color = SmartVanColors.Naranja, fontSize = 12.sp
                    )
                }
                FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    puntosOrigenFiltrados.forEach { punto ->
                        val seleccionado = puntosSubidaSeleccionados.contains(punto.nombre)
                        FilterChip(
                            selected = seleccionado,
                            onClick = {
                                puntosSubidaSeleccionados = if (seleccionado)
                                    puntosSubidaSeleccionados.filter { it != punto.nombre }
                                else puntosSubidaSeleccionados + punto.nombre
                            },
                            label = {
                                Column {
                                    Text(punto.nombre, fontSize = 13.sp, fontWeight = if (seleccionado) FontWeight.Bold else FontWeight.Normal)
                                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                                        if (punto.hora.isNotBlank()) {
                                            Text(punto.hora, fontSize = 10.sp, color = Color.Gray)
                                        }
                                        EtiquetaDias(punto.dias)
                                    }
                                }
                            },
                            leadingIcon = if (seleccionado) { { Icon(Icons.Filled.CheckCircle, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(16.dp)) } } else null,
                            colors = FilterChipDefaults.filterChipColors(
                                selectedContainerColor = SmartVanColors.Azul.copy(alpha = 0.15f)
                            )
                        )
                    }
                }
                if (puntosSubidaSeleccionados.isNotEmpty()) {
                    val horasResumen = puntosSubidaSeleccionados.mapNotNull { nombre ->
                        puntosSubidaInfo.find { it.nombre == nombre }?.let { "${it.nombre} (${it.hora.ifBlank { "sin hora" }})" }
                    }.joinToString(" · ")
                    Text("Salidas: $horasResumen", color = SmartVanColors.Azul, fontSize = 11.sp, fontWeight = FontWeight.Medium)
                }

                HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp), color = SmartVanColors.FondoGris)

                // --- Sección: Asignación ---
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(32.dp).background(SmartVanColors.Naranja.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.People, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(18.dp))
                    }
                    Spacer(modifier = Modifier.width(10.dp))
                    Text("Asignación de Personal", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                }

                AdminDropdown("Asignar Chofer", choferes, chofer, { chofer = it }, Modifier.fillMaxWidth())
                AdminDropdown("Vehículo Asignado", vehiculos, vehiculo, { vehiculo = it }, Modifier.fillMaxWidth())

                HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp), color = SmartVanColors.FondoGris)

                // --- Sección: Recurrencia ---
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(32.dp).background(SmartVanColors.Purpura.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.Timer, contentDescription = null, tint = SmartVanColors.Purpura, modifier = Modifier.size(18.dp))
                    }
                    Spacer(modifier = Modifier.width(10.dp))
                    Text("Recurrencia del Viaje", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                }
                Spacer(modifier = Modifier.height(4.dp))

                FlowRow(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center,
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    listOf(
                        "Único" to "1 día",
                        "Entre semana" to "Lun a Vie",
                        "Sábados" to "Solo sábados",
                        "Personalizado" to "Rango",
                        "Semanal" to "7 días",
                        "Mensual" to "30 días",
                        "Indefinido" to "Continuo"
                    ).forEach { (option, subtitulo) ->
                        val isSelected = recurrencia == option
                        Card(
                            modifier = Modifier
                                .padding(horizontal = 4.dp)
                                .clickable { recurrencia = option },
                            colors = CardDefaults.cardColors(
                                containerColor = if (isSelected) SmartVanColors.AzulOscuro else Color(0xFFF3F4F6)
                            ),
                            shape = RoundedCornerShape(10.dp),
                            elevation = CardDefaults.cardElevation(
                                defaultElevation = if (isSelected) 4.dp else 0.dp
                            )
                        ) {
                            Column(
                                modifier = Modifier.padding(horizontal = 14.dp, vertical = 10.dp),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                Text(
                                    option,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 13.sp,
                                    color = if (isSelected) Color.White else SmartVanColors.AzulOscuro
                                )
                                Text(
                                    subtitulo,
                                    fontSize = 10.sp,
                                    color = if (isSelected) Color.White.copy(alpha = 0.7f) else Color.Gray
                                )
                            }
                        }
                    }
                }
                if (recurrencia == "Sábados" || recurrencia == "Entre semana") {
                    val esSab = recurrencia == "Sábados"
                    val valor = if (esSab) sabadosACrear else semanasACrear
                    val maximo = if (esSab) 26 else 12
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        Text(
                            if (esSab) "¿Cuántos sábados programar?" else "¿Cuántas semanas programar?",
                            fontSize = 13.sp, fontWeight = FontWeight.SemiBold,
                            color = SmartVanColors.AzulOscuro, modifier = Modifier.weight(1f)
                        )
                        OutlinedButton(
                            onClick = { if (esSab) sabadosACrear = (valor - 1).coerceAtLeast(1) else semanasACrear = (valor - 1).coerceAtLeast(1) },
                            enabled = valor > 1,
                            contentPadding = PaddingValues(0.dp),
                            modifier = Modifier.size(38.dp)
                        ) { Text("−", fontSize = 18.sp, fontWeight = FontWeight.Bold) }
                        Text(
                            valor.toString(),
                            fontSize = 18.sp, fontWeight = FontWeight.Black,
                            color = SmartVanColors.AzulOscuro,
                            modifier = Modifier.widthIn(min = 28.dp),
                            textAlign = TextAlign.Center
                        )
                        OutlinedButton(
                            onClick = { if (esSab) sabadosACrear = (valor + 1).coerceAtMost(maximo) else semanasACrear = (valor + 1).coerceAtMost(maximo) },
                            enabled = valor < maximo,
                            contentPadding = PaddingValues(0.dp),
                            modifier = Modifier.size(38.dp)
                        ) { Text("+", fontSize = 18.sp, fontWeight = FontWeight.Bold) }
                    }
                    if (esSab) {
                        Text(
                            "Se cuenta desde el próximo sábado (${fechaCorta(fechasPrevistas.firstOrNull() ?: fechaInicio)}). Máximo $maximo.",
                            fontSize = 11.sp, color = Color.Gray
                        )
                    }
                }
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoCyan),
                    modifier = Modifier.fillMaxWidth().padding(top = 8.dp)
                ) {
                    Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.Schedule, contentDescription = null, tint = Color(0xFF006064), modifier = Modifier.size(20.dp).padding(end = 4.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text(
                            text = leyendaProyeccion,
                            style = MaterialTheme.typography.bodySmall,
                            color = Color(0xFF006064),
                            fontWeight = FontWeight.Medium
                        )
                    }
                }
                if (showDatePickerInicio) {
                    DatePickerDialog(
                        onDismissRequest = { showDatePickerInicio = false },
                        confirmButton = {
                            TextButton(onClick = {
                                datePickerStateInicio.selectedDateMillis?.let { millis ->
                                    val elegida = org.example.abigail.formatMillisToDate(millis)
                                    // Si la recurrencia es por tipo de día, se corre al primer
                                    // día válido para que la fecha nunca contradiga al modo.
                                    fechaInicio = when (recurrencia) {
                                        "Sábados" -> proximoSabado(elegida)
                                        "Entre semana" -> proximoDiaEntreSemana(elegida)
                                        else -> elegida
                                    }
                                }
                                showDatePickerInicio = false
                            }) { Text("Aceptar", color = SmartVanColors.AzulOscuro) }
                        },
                        dismissButton = {
                            TextButton(onClick = { showDatePickerInicio = false }) { Text("Cancelar") }
                        }
                    ) {
                        DatePicker(state = datePickerStateInicio, showModeToggle = false)
                    }
                }

                if (showDatePickerFin) {
                    DatePickerDialog(
                        onDismissRequest = { showDatePickerFin = false },
                        confirmButton = {
                            TextButton(onClick = {
                                datePickerStateFin.selectedDateMillis?.let { millis ->
                                    fechaFin = org.example.abigail.formatMillisToDate(millis)
                                }
                                showDatePickerFin = false
                            }) { Text("Aceptar", color = SmartVanColors.AzulOscuro) }
                        },
                        dismissButton = {
                            TextButton(onClick = { showDatePickerFin = false }) { Text("Cancelar") }
                        }
                    ) {
                        DatePicker(state = datePickerStateFin, showModeToggle = false)
                    }
                }
                var mostrarAlerta by remember { mutableStateOf(false) }

                Button(
                    onClick = {
                        // El horario del viaje = punto MÁS TEMPRANO (la salida real del viaje).
                        val primerHora = puntosSubidaSeleccionados
                            .mapNotNull { nombre -> puntosSubidaInfo.find { it.nombre == nombre }?.hora?.takeIf { it.isNotBlank() } }
                            .minByOrNull { horaAMinutos(it) } ?: ""
                        if (origen.isNotBlank() && destino.isNotBlank() && puntosSubidaSeleccionados.isNotEmpty() && chofer.isNotBlank() && vehiculo.isNotBlank()) {
                            viewModel.publicarItinerario(
                                origen = origen,
                                destino = destino,
                                fechaInicio = fechaInicio,
                                fechaFin = fechaFin,
                                horario = primerHora.ifBlank { "06:00 AM" },
                                chofer = chofer,
                                vehiculo = vehiculo,
                                recurrencia = recurrencia,
                                puntoSubida = puntosSubidaSeleccionados.joinToString("|"),
                                repeticiones = if (recurrencia == "Sábados") sabadosACrear else semanasACrear
                            )
                            mostrarAlerta = true
                        }
                    },
                    modifier = Modifier.fillMaxWidth().height(50.dp).padding(top = 8.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = if (origen.isNotBlank() && destino.isNotBlank() && puntosSubidaSeleccionados.isNotEmpty() && chofer.isNotBlank() && vehiculo.isNotBlank()) SmartVanColors.AzulOscuro else Color.LightGray
                    ),
                    enabled = origen.isNotBlank() && destino.isNotBlank() && puntosSubidaSeleccionados.isNotEmpty() && chofer.isNotBlank() && vehiculo.isNotBlank()
                ) {
                    Text("Publicar Itinerario", fontWeight = FontWeight.Bold, color = Color.White)
                }
                if (mostrarAlerta) {
                    AlertDialog(
                        onDismissRequest = { mostrarAlerta = false },
                        title = { Text("¡Éxito!") },
                        text = { Text("Los viajes han sido programados correctamente en la base de datos.") },
                        confirmButton = {
                            TextButton(onClick = {
                                mostrarAlerta = false
                            }) { Text("Aceptar", color = SmartVanColors.AzulOscuro) }
                        }
                    )
                }
            }
        }
    }
}
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ManagedDataView(viewModel: AdminViewModel) {
    val ciudades by viewModel.ciudades.collectAsState()
    val choferes by viewModel.choferes.collectAsState()
    val vehiculos by viewModel.vehiculos.collectAsState()
    val horarios by viewModel.horarios.collectAsState()
    val paradas by viewModel.paradas.collectAsState()
    val paradasInfo by viewModel.paradasInfo.collectAsState()
    val puntosSubida by viewModel.puntosSubida.collectAsState()
    val puntosSubidaInfo by viewModel.puntosSubidaInfo.collectAsState()
    val vehiculosConfig by viewModel.vehiculosConfig.collectAsState()

    LaunchedEffect(Unit) { viewModel.cargarVehiculosConfig() }

    var itemToDelete by remember { mutableStateOf<Triple<String, String, List<String>>?>(null) }
    var itemToEdit by remember { mutableStateOf<Triple<String, String, List<String>>?>(null) }
    var vehiculoAEditar by remember { mutableStateOf<VehiculoConfig?>(null) }
    var editNewValue by remember { mutableStateOf("") }
    // Estado para edición enriquecida de paradas/subidas
    var editCiudad by remember { mutableStateOf("") }
    var editLat by remember { mutableStateOf("") }
    var editLng by remember { mutableStateOf("") }
    var editHora by remember { mutableStateOf("") }
    var editDias by remember { mutableStateOf(TipoDia.TODOS) }
    var newItemValue by remember { mutableStateOf("") }
    var categoryToAdd by remember { mutableStateOf<Pair<String, List<String>>?>(null) }

    data class CategoriaInfo(val titulo: String, val items: List<String>, val key: String, val icon: @Composable () -> Unit, val color: Color)

    val categorias = listOf(
        CategoriaInfo("Ciudades (Origen/Destino)", ciudades, "ciudades",
            { Icon(Icons.Filled.LocationCity, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(20.dp)) },
            SmartVanColors.CyanAccent
        ),
        CategoriaInfo("Puntos de Subida (Salida)", puntosSubida, "puntosSubida",
            { Icon(Icons.Filled.TripOrigin, contentDescription = null, tint = SmartVanColors.Azul, modifier = Modifier.size(20.dp)) },
            SmartVanColors.Azul
        ),
        CategoriaInfo("Paradas (Puntos de Bajada)", paradas, "paradas",
            { Icon(Icons.Filled.LocationOn, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(20.dp)) },
            SmartVanColors.Verde
        ),
        CategoriaInfo("Vehículos (Flota)", vehiculos, "vehiculos",
            { Icon(Icons.Filled.DirectionsBus, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(20.dp)) },
            SmartVanColors.Naranja
        ),
        CategoriaInfo("Horarios Disponibles", horarios, "horarios",
            { Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.Purpura, modifier = Modifier.size(20.dp)) },
            SmartVanColors.Purpura
        )
    )

    Column(modifier = Modifier.fillMaxSize().padding(16.dp).verticalScroll(rememberScrollState())) {
        Text("Administrar Catálogos", style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
        Text("Editar estos datos NO afectará los viajes ya publicados.", color = Color.Gray, style = MaterialTheme.typography.bodySmall)
        Spacer(modifier = Modifier.height(16.dp))

        categorias.forEach { categoria ->
            val tituloVisual = categoria.titulo
            val listaActual = categoria.items
            val keyFirebase = categoria.key

            Card(
                modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp),
                colors = CardDefaults.cardColors(containerColor = Color.White),
                elevation = CardDefaults.cardElevation(2.dp),
                shape = RoundedCornerShape(16.dp)
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(bottom = 4.dp)) {
                        Box(
                            modifier = Modifier.size(36.dp).background(categoria.color.copy(alpha = 0.1f), CircleShape),
                            contentAlignment = Alignment.Center
                        ) {
                            categoria.icon()
                        }
                        Spacer(modifier = Modifier.width(12.dp))
                        Column {
                            Text(tituloVisual, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                            Text("${listaActual.size} registros", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                        }
                    }
                    HorizontalDivider(modifier = Modifier.padding(vertical = 8.dp), color = SmartVanColors.FondoGris)

                    listaActual.forEach { item ->
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(modifier = Modifier.weight(1f)) {
                                // Mostrar info enriquecida para paradas y puntos de subida
                                if (keyFirebase == "paradas" || keyFirebase == "puntosSubida") {
                                    val infoLista = if (keyFirebase == "paradas") paradasInfo else puntosSubidaInfo
                                    val info = infoLista.find { it.nombre == item }
                                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                                        Text(item, modifier = Modifier.weight(1f, fill = false))
                                        EtiquetaDias(info?.dias ?: "")
                                    }
                                    if (info != null && info.ciudad.isNotBlank()) {
                                        val horaTexto = if (keyFirebase == "puntosSubida" && info.hora.isNotBlank()) " · ${info.hora}" else ""
                                        Text(
                                            "${info.ciudad} · ${if (info.lat != 0.0) "${info.lat.toString().take(8)}, ${info.lng.toString().take(9)}" else "Sin coordenadas"}$horaTexto",
                                            color = Color.Gray, fontSize = 11.sp
                                        )
                                    } else {
                                        Text("Sin ciudad asignada", color = SmartVanColors.Naranja, fontSize = 11.sp)
                                    }
                                } else {
                                    Text(item)
                                }
                            }
                            Row {
                                IconButton(onClick = {
                                    if (keyFirebase == "vehiculos") {
                                        // Editor completo (marca/modelo/placas/layout) precargado
                                        vehiculoAEditar = vehiculosConfig.find { it.nombre == item }
                                            ?: VehiculoConfig(nombre = item)
                                        return@IconButton
                                    }
                                    editNewValue = item
                                    // Precargar info enriquecida si es parada o subida
                                    if (keyFirebase == "paradas") {
                                        val info = paradasInfo.find { it.nombre == item }
                                        editCiudad = info?.ciudad ?: ""
                                        editLat = if (info != null && info.lat != 0.0) info.lat.toString() else ""
                                        editLng = if (info != null && info.lng != 0.0) info.lng.toString() else ""
                                        editHora = ""
                                        editDias = TipoDia.normalizar(info?.dias ?: "")
                                    } else if (keyFirebase == "puntosSubida") {
                                        val info = puntosSubidaInfo.find { it.nombre == item }
                                        editCiudad = info?.ciudad ?: ""
                                        editLat = if (info != null && info.lat != 0.0) info.lat.toString() else ""
                                        editLng = if (info != null && info.lng != 0.0) info.lng.toString() else ""
                                        editHora = info?.hora ?: ""
                                        editDias = TipoDia.normalizar(info?.dias ?: "")
                                    } else if (keyFirebase == "horarios") {
                                        editCiudad = ""; editLat = ""; editLng = ""; editHora = item; editDias = TipoDia.TODOS
                                    } else {
                                        editCiudad = ""; editLat = ""; editLng = ""; editHora = ""; editDias = TipoDia.TODOS
                                    }
                                    itemToEdit = Triple(keyFirebase, item, listaActual)
                                }) {
                                    Icon(Icons.Filled.Edit, contentDescription = "Editar", tint = SmartVanColors.AzulOscuro)
                                }
                                IconButton(onClick = {
                                    itemToDelete = Triple(keyFirebase, item, listaActual)
                                }) {
                                    Icon(Icons.Filled.Delete, contentDescription = "Borrar", tint = Color.Red)
                                }
                            }
                        }
                        HorizontalDivider(color = Color.LightGray.copy(alpha = 0.3f))
                    }

                    TextButton(
                        onClick = { categoryToAdd = Pair(keyFirebase, listaActual) },
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text("+ Agregar Nuevo", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
    }

    if (itemToDelete != null) {
        AlertDialog(
            onDismissRequest = { itemToDelete = null },
            title = { Text("Confirmar Acción") },
            text = { Text("¿Estás seguro de que deseas eliminar '${itemToDelete!!.second}'? Esta acción no se puede deshacer.") },
            confirmButton = {
                TextButton(onClick = {
                    viewModel.eliminarDato(itemToDelete!!.first, itemToDelete!!.second, itemToDelete!!.third)
                    itemToDelete = null
                }) { Text("Eliminar", color = Color.Red, fontWeight = FontWeight.Bold) }
            },
            dismissButton = {
                TextButton(onClick = { itemToDelete = null }) { Text("Cancelar") }
            }
        )
    }

    if (itemToEdit != null) {
        val editKey = itemToEdit!!.first
        val editOriginalName = itemToEdit!!.second
        val editLista = itemToEdit!!.third
        val esParadaOSubida = editKey == "paradas" || editKey == "puntosSubida"
        val esSubida = editKey == "puntosSubida"
        val esHorario = editKey == "horarios"
        val esCiudad = editKey == "ciudades"
        val estadosMexicoEdit = listOf("Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "CDMX", "Coahuila", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas")

        val scope = rememberCoroutineScope()
        var editEstadoExpanded by remember { mutableStateOf(false) }
        var editCiudadExpanded by remember { mutableStateOf(false) }
        var editGeocodificando by remember { mutableStateOf(false) }
        var editGeoMsg by remember { mutableStateOf("") }
        var editMapsLink by remember { mutableStateOf("") }
        var editExtrayendo by remember { mutableStateOf(false) }
        val editTimePickerState = rememberTimePickerState(
            initialHour = editHora.let {
                try {
                    val parts = it.replace(" AM", "").replace(" PM", "").split(":")
                    var h = parts[0].trim().toInt()
                    if (it.contains("PM") && h != 12) h += 12
                    if (it.contains("AM") && h == 12) h = 0
                    h
                } catch (_: Exception) { 8 }
            },
            initialMinute = editHora.let {
                try { it.replace(" AM", "").replace(" PM", "").split(":")[1].trim().toInt() } catch (_: Exception) { 0 }
            }
        )

        AlertDialog(
            onDismissRequest = { itemToEdit = null },
            title = { Text(
                when (editKey) {
                    "paradas" -> "Editar Parada"
                    "puntosSubida" -> "Editar Punto de Subida"
                    "horarios" -> "Editar Horario"
                    "ciudades" -> "Editar Estado"
                    else -> "Editar Dato"
                }, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
            },
            text = {
                Column(
                    modifier = Modifier.fillMaxWidth().heightIn(max = if (esSubida) 520.dp else if (esParadaOSubida) 440.dp else if (esHorario) 260.dp else 120.dp).verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    when {
                        esHorario -> {
                            Text("Hora:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                            TimeInput(state = editTimePickerState)
                            val isPmE = editTimePickerState.hour >= 12
                            val dHE = if (editTimePickerState.hour % 12 == 0) 12 else editTimePickerState.hour % 12
                            val dME = editTimePickerState.minute.toString().padStart(2, '0')
                            Text("Hora asignada: ${dHE.toString().padStart(2, '0')}:$dME ${if (isPmE) "PM" else "AM"}", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.SemiBold, fontSize = 13.sp)
                        }
                        esCiudad -> {
                            AdminDropdown("Estado", estadosMexicoEdit, editNewValue, { editNewValue = it }, Modifier.fillMaxWidth())
                        }
                        else -> {
                            OutlinedTextField(
                                value = editNewValue,
                                onValueChange = { editNewValue = it },
                                label = { Text("Nombre") },
                                singleLine = true,
                                modifier = Modifier.fillMaxWidth()
                            )
                        }
                    }

                    if (esParadaOSubida) {
                        SelectorDiasServicio(editDias) { editDias = it }
                        // Dropdown de ciudad
                        Text("Ciudad:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                        Box {
                            OutlinedTextField(
                                value = editCiudad,
                                onValueChange = {},
                                readOnly = true,
                                label = { Text("Ciudad") },
                                trailingIcon = {
                                    IconButton(onClick = { editCiudadExpanded = !editCiudadExpanded }) {
                                        Icon(Icons.Filled.ArrowDropDown, contentDescription = null)
                                    }
                                },
                                modifier = Modifier.fillMaxWidth(),
                                singleLine = true
                            )
                            DropdownMenu(expanded = editCiudadExpanded, onDismissRequest = { editCiudadExpanded = false }) {
                                ciudades.forEach { ciudad ->
                                    DropdownMenuItem(
                                        text = { Text(ciudad) },
                                        onClick = { editCiudad = ciudad; editCiudadExpanded = false }
                                    )
                                }
                            }
                        }

                        // Link de Google Maps
                        OutlinedTextField(
                            value = editMapsLink,
                            onValueChange = { editMapsLink = it },
                            label = { Text("Link de Google Maps") },
                            placeholder = { Text("Pega un link de Google Maps aquí") },
                            leadingIcon = { Icon(Icons.Filled.Map, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(16.dp)) },
                            modifier = Modifier.fillMaxWidth(),
                            singleLine = true
                        )
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Button(
                                onClick = {
                                    editExtrayendo = true
                                    editGeoMsg = ""
                                    scope.launch {
                                        val coords = extraerCoordsDeGoogleMaps(editMapsLink)
                                        if (coords != null) {
                                            editLat = coords.first.toString()
                                            editLng = coords.second.toString()
                                            editGeoMsg = "Coordenadas extraidas del link"
                                        } else {
                                            editGeoMsg = "No se pudieron extraer coordenadas del link"
                                        }
                                        editExtrayendo = false
                                    }
                                },
                                enabled = !editExtrayendo && editMapsLink.isNotBlank(),
                                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                                modifier = Modifier.weight(1f)
                            ) {
                                if (editExtrayendo) CircularProgressIndicator(color = Color.White, modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                else Icon(Icons.Filled.LocationOn, contentDescription = null, tint = Color.White, modifier = Modifier.size(16.dp))
                                Spacer(modifier = Modifier.width(4.dp))
                                Text("Del Link", color = Color.White, fontSize = 12.sp)
                            }
                            OutlinedButton(
                                onClick = {
                                    if (editNewValue.isNotBlank()) {
                                        editGeocodificando = true
                                        editGeoMsg = ""
                                        scope.launch {
                                            val query = if (editCiudad.isNotBlank()) "${editNewValue.trim()}, $editCiudad" else editNewValue.trim()
                                            val coords = geocodificarCiudad(query)
                                            if (coords != null) {
                                                editLat = coords.first.toString()
                                                editLng = coords.second.toString()
                                                editGeoMsg = "Coordenadas encontradas"
                                            } else {
                                                editGeoMsg = "No se encontraron coordenadas"
                                            }
                                            editGeocodificando = false
                                        }
                                    }
                                },
                                enabled = !editGeocodificando && editNewValue.isNotBlank(),
                                modifier = Modifier.weight(1f)
                            ) {
                                if (editGeocodificando) CircularProgressIndicator(modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                else Text("Por nombre", fontSize = 12.sp)
                            }
                        }
                        // Coordenadas
                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            OutlinedTextField(value = editLat, onValueChange = { editLat = it }, label = { Text("Latitud") }, singleLine = true, modifier = Modifier.weight(1f))
                            OutlinedTextField(value = editLng, onValueChange = { editLng = it }, label = { Text("Longitud") }, singleLine = true, modifier = Modifier.weight(1f))
                        }
                        if (editGeoMsg.isNotBlank()) {
                            Text(editGeoMsg, fontSize = 11.sp, color = if (editGeoMsg.contains("encontrad") || editGeoMsg.contains("extraid")) SmartVanColors.VerdeOscuro else Color.Red)
                        }

                        // Hora para puntos de subida
                        if (esSubida) {
                            HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))
                            Text("Hora de salida:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                            TimeInput(state = editTimePickerState)
                            val isPm = editTimePickerState.hour >= 12
                            val displayH = if (editTimePickerState.hour % 12 == 0) 12 else editTimePickerState.hour % 12
                            val displayM = editTimePickerState.minute.toString().padStart(2, '0')
                            Text("Hora asignada: $displayH:$displayM ${if (isPm) "PM" else "AM"}", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.SemiBold, fontSize = 13.sp)
                        }
                    }
                }
            },
            confirmButton = {
                TextButton(onClick = {
                    if (esParadaOSubida) {
                        val lat = editLat.toDoubleOrNull() ?: 0.0
                        val lng = editLng.toDoubleOrNull() ?: 0.0
                        if (esSubida) {
                            val isPm = editTimePickerState.hour >= 12
                            val dH = if (editTimePickerState.hour % 12 == 0) 12 else editTimePickerState.hour % 12
                            val dM = editTimePickerState.minute.toString().padStart(2, '0')
                            val horaFinal = "$dH:$dM ${if (isPm) "PM" else "AM"}"
                            viewModel.editarPuntoSubidaConInfo(editOriginalName, editNewValue.trim(), editCiudad, lat, lng, horaFinal, editLista, editDias)
                        } else {
                            viewModel.editarParadaConInfo(editOriginalName, editNewValue.trim(), editCiudad, lat, lng, editLista, editDias)
                        }
                    } else if (esHorario) {
                        val isPmE = editTimePickerState.hour >= 12
                        val dHE = if (editTimePickerState.hour % 12 == 0) 12 else editTimePickerState.hour % 12
                        val dME = editTimePickerState.minute.toString().padStart(2, '0')
                        val horaFmt = "${dHE.toString().padStart(2, '0')}:$dME ${if (isPmE) "PM" else "AM"}"
                        viewModel.editarDato(editKey, editOriginalName, horaFmt, editLista)
                    } else {
                        viewModel.editarDato(editKey, editOriginalName, editNewValue.trim(), editLista)
                    }
                    itemToEdit = null
                }) { Text("Guardar", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { itemToEdit = null }) { Text("Cancelar") } }
        )
    }

    vehiculoAEditar?.let { vConfig ->
        val nombreViejo = vConfig.nombre
        var eMarca by remember(nombreViejo) { mutableStateOf(vConfig.marca) }
        var eModelo by remember(nombreViejo) { mutableStateOf(vConfig.modelo) }
        var ePlacas by remember(nombreViejo) { mutableStateOf(vConfig.placas) }
        var eFilas by remember(nombreViejo) {
            mutableStateOf(
                vConfig.filas.ifEmpty {
                    listOf(
                        FilaVehiculo(listOf(-1, 0, 0, 1)),
                        FilaVehiculo(listOf(2, 3, 0, 4)),
                        FilaVehiculo(listOf(5, 6, 0, 7)),
                        FilaVehiculo(listOf(8, 9, 0, 10)),
                        FilaVehiculo(listOf(11, 12, 13, 0)),
                    )
                }
            )
        }
        val eCapacidad = eFilas.sumOf { f -> f.asientos.count { it > 0 } }

        AlertDialog(
            onDismissRequest = { vehiculoAEditar = null },
            title = { Text("Editar Vehículo", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro) },
            text = {
                Column(
                    modifier = Modifier.fillMaxWidth().heightIn(max = 520.dp).verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    OutlinedTextField(value = eMarca, onValueChange = { eMarca = it }, label = { Text("Marca/Tipo (Ej. Sprinter)") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                    OutlinedTextField(value = eModelo, onValueChange = { eModelo = it }, label = { Text("Modelo (Ej. 2025)") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                    OutlinedTextField(value = ePlacas, onValueChange = { ePlacas = it }, label = { Text("Placas") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                    Text("Capacidad actual: $eCapacidad asiento(s)", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.SemiBold, fontSize = 13.sp)
                    Spacer(modifier = Modifier.height(8.dp))
                    ConfiguradorAsientos(
                        filasActuales = eFilas,
                        columnas = eFilas.firstOrNull()?.asientos?.size ?: 4,
                        onFilasChange = { eFilas = it }
                    )
                }
            },
            confirmButton = {
                TextButton(
                    onClick = {
                        val nuevoNombre = "$eMarca $eModelo ($ePlacas)".trim()
                        viewModel.editarVehiculoConfig(
                            nombreViejo = nombreViejo,
                            vehiculo = vConfig.copy(
                                nombre = nuevoNombre,
                                marca = eMarca.trim(),
                                modelo = eModelo.trim(),
                                placas = ePlacas.trim(),
                                capacidad = eCapacidad,
                                columnas = eFilas.firstOrNull()?.asientos?.size ?: 4,
                                filas = eFilas
                            )
                        )
                        vehiculoAEditar = null
                    },
                    enabled = eMarca.isNotBlank() && ePlacas.isNotBlank()
                ) { Text("Guardar", color = SmartVanColors.AzulOscuro, fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { vehiculoAEditar = null }) { Text("Cancelar") } }
        )
    }

    if (categoryToAdd != null) {
        val clave = categoryToAdd!!.first
        val listaGuardada = categoryToAdd!!.second

        val scope = rememberCoroutineScope()
        var ciudadName by remember { mutableStateOf("") }
        var estadoName by remember { mutableStateOf("") }

        // Para parada con ciudad y geocodificación
        var paradaNombre by remember { mutableStateOf("") }
        var paradaCiudad by remember { mutableStateOf("") }
        var paradaCiudadExpanded by remember { mutableStateOf(false) }
        var paradaLat by remember { mutableStateOf("") }
        var paradaLng by remember { mutableStateOf("") }
        var geocodificando by remember { mutableStateOf(false) }
        var paradaMapsLink by remember { mutableStateOf("") }
        var paradaExtrayendo by remember { mutableStateOf(false) }
        var paradaDias by remember { mutableStateOf(TipoDia.TODOS) }

        // Para punto de subida con ciudad y geocodificación
        var subidaNombre by remember { mutableStateOf("") }
        var subidaCiudad by remember { mutableStateOf("") }
        var subidaCiudadExpanded by remember { mutableStateOf(false) }
        var subidaLat by remember { mutableStateOf("") }
        var subidaLng by remember { mutableStateOf("") }
        var geocodificandoSubida by remember { mutableStateOf(false) }
        var subidaMapsLink by remember { mutableStateOf("") }
        var subidaExtrayendo by remember { mutableStateOf(false) }
        var subidaDias by remember { mutableStateOf(TipoDia.TODOS) }
        val subidaTimePickerState = rememberTimePickerState()

        var vehiculoMarca by remember { mutableStateOf("") }
        var vehiculoModelo by remember { mutableStateOf("") }
        var vehiculoPlacas by remember { mutableStateOf("") }
        var filasVehiculo by remember {
            mutableStateOf(listOf(
                FilaVehiculo(listOf(-1, 0, 0, 1)),
                FilaVehiculo(listOf(2, 3, 0, 4)),
                FilaVehiculo(listOf(5, 6, 0, 7)),
                FilaVehiculo(listOf(8, 9, 0, 10)),
                FilaVehiculo(listOf(11, 12, 13, 0)),
            ))
        }

        val timePickerState = rememberTimePickerState()

        val estadosMexico = listOf("Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "CDMX", "Coahuila", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas")

        AlertDialog(
            onDismissRequest = { categoryToAdd = null },
            title = { Text(
                when(clave) {
                    "ciudades" -> "Agregar Nueva Ciudad"
                    "paradas" -> "Agregar Nueva Parada"
                    "puntosSubida" -> "Agregar Punto de Subida"
                    "vehiculos" -> "Registrar Vehículo"
                    "horarios" -> "Definir Nuevo Horario"
                    else -> "Agregar Dato"
                }, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
            },
            text = {
                Column(
                    modifier = Modifier.fillMaxWidth().heightIn(max = 480.dp).verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    when (clave) {
                        "ciudades" -> {
                            AdminDropdown("Estado", estadosMexico, estadoName, { estadoName = it }, Modifier.fillMaxWidth())
                        }
                        "paradas" -> {
                            OutlinedTextField(
                                value = paradaNombre,
                                onValueChange = { paradaNombre = it },
                                label = { Text("Nombre de la Parada (Ej. Terminal Centro)") },
                                singleLine = true,
                                modifier = Modifier.fillMaxWidth()
                            )
                            SelectorDiasServicio(paradaDias) { paradaDias = it }
                            // Dropdown de ciudad
                            Text("Ciudad a la que pertenece:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                            Box {
                                OutlinedTextField(
                                    value = paradaCiudad,
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("Ciudad") },
                                    trailingIcon = {
                                        IconButton(onClick = { paradaCiudadExpanded = !paradaCiudadExpanded }) {
                                            Icon(Icons.Filled.ArrowDropDown, contentDescription = null)
                                        }
                                    },
                                    modifier = Modifier.fillMaxWidth(),
                                    singleLine = true
                                )
                                DropdownMenu(expanded = paradaCiudadExpanded, onDismissRequest = { paradaCiudadExpanded = false }) {
                                    ciudades.forEach { ciudad ->
                                        DropdownMenuItem(
                                            text = { Text(ciudad) },
                                            onClick = { paradaCiudad = ciudad; paradaCiudadExpanded = false }
                                        )
                                    }
                                }
                            }
                            // Botón geocodificar
                            // Link de Google Maps
                            OutlinedTextField(
                                value = paradaMapsLink,
                                onValueChange = { paradaMapsLink = it },
                                label = { Text("Link de Google Maps") },
                                placeholder = { Text("Pega el link de Google Maps aquí") },
                                leadingIcon = { Icon(Icons.Filled.Map, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(18.dp)) },
                                modifier = Modifier.fillMaxWidth(),
                                singleLine = true,
                                supportingText = { Text("Pega un link de Google Maps para obtener las coordenadas automaticamente", style = MaterialTheme.typography.labelSmall, color = Color.Gray) }
                            )
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                Button(
                                    onClick = {
                                        paradaExtrayendo = true
                                        scope.launch {
                                            val coords = extraerCoordsDeGoogleMaps(paradaMapsLink)
                                            if (coords != null) {
                                                paradaLat = coords.first.toString()
                                                paradaLng = coords.second.toString()
                                            }
                                            paradaExtrayendo = false
                                        }
                                    },
                                    enabled = !paradaExtrayendo && paradaMapsLink.isNotBlank(),
                                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                                    modifier = Modifier.weight(1f)
                                ) {
                                    if (paradaExtrayendo) {
                                        CircularProgressIndicator(color = Color.White, modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                    } else {
                                        Icon(Icons.Filled.LocationOn, contentDescription = null, tint = Color.White, modifier = Modifier.size(16.dp))
                                    }
                                    Spacer(modifier = Modifier.width(4.dp))
                                    Text("Extraer del Link", color = Color.White, fontSize = 12.sp)
                                }
                                if (paradaNombre.isNotBlank() && paradaCiudad.isNotBlank()) {
                                    OutlinedButton(
                                        onClick = {
                                            geocodificando = true
                                            scope.launch {
                                                val coords = geocodificarCiudad("$paradaNombre, $paradaCiudad")
                                                if (coords != null) {
                                                    paradaLat = coords.first.toString()
                                                    paradaLng = coords.second.toString()
                                                }
                                                geocodificando = false
                                            }
                                        },
                                        enabled = !geocodificando,
                                        modifier = Modifier.weight(1f)
                                    ) {
                                        if (geocodificando) CircularProgressIndicator(modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                        else Text("Buscar por nombre", fontSize = 12.sp)
                                    }
                                }
                            }
                            // Campos de coordenadas (editables por si quieren ajustar)
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = paradaLat, onValueChange = { paradaLat = it }, label = { Text("Latitud") }, singleLine = true, modifier = Modifier.weight(1f))
                                OutlinedTextField(value = paradaLng, onValueChange = { paradaLng = it }, label = { Text("Longitud") }, singleLine = true, modifier = Modifier.weight(1f))
                            }
                            if (paradaLat.isNotBlank() && paradaLng.isNotBlank()) {
                                Text("Coordenadas listas — se incorporara automaticamente a las rutas de $paradaCiudad",
                                    color = SmartVanColors.Verde, fontSize = 11.sp)
                            }
                        }
                        "puntosSubida" -> {
                            OutlinedTextField(
                                value = subidaNombre,
                                onValueChange = { subidaNombre = it },
                                label = { Text("Nombre del Punto (Ej. Terminal Centro Qro.)") },
                                singleLine = true,
                                modifier = Modifier.fillMaxWidth()
                            )
                            SelectorDiasServicio(subidaDias) { subidaDias = it }
                            Text("Ciudad a la que pertenece:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                            Box {
                                OutlinedTextField(
                                    value = subidaCiudad,
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("Ciudad") },
                                    trailingIcon = {
                                        IconButton(onClick = { subidaCiudadExpanded = !subidaCiudadExpanded }) {
                                            Icon(Icons.Filled.ArrowDropDown, contentDescription = null)
                                        }
                                    },
                                    modifier = Modifier.fillMaxWidth(),
                                    singleLine = true
                                )
                                DropdownMenu(expanded = subidaCiudadExpanded, onDismissRequest = { subidaCiudadExpanded = false }) {
                                    ciudades.forEach { ciudad ->
                                        DropdownMenuItem(
                                            text = { Text(ciudad) },
                                            onClick = { subidaCiudad = ciudad; subidaCiudadExpanded = false }
                                        )
                                    }
                                }
                            }
                            // Link de Google Maps
                            OutlinedTextField(
                                value = subidaMapsLink,
                                onValueChange = { subidaMapsLink = it },
                                label = { Text("Link de Google Maps") },
                                placeholder = { Text("Pega el link de Google Maps aquí") },
                                leadingIcon = { Icon(Icons.Filled.Map, contentDescription = null, tint = SmartVanColors.Azul, modifier = Modifier.size(18.dp)) },
                                modifier = Modifier.fillMaxWidth(),
                                singleLine = true,
                                supportingText = { Text("Pega un link de Google Maps para obtener las coordenadas automaticamente", style = MaterialTheme.typography.labelSmall, color = Color.Gray) }
                            )
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                Button(
                                    onClick = {
                                        subidaExtrayendo = true
                                        scope.launch {
                                            val coords = extraerCoordsDeGoogleMaps(subidaMapsLink)
                                            if (coords != null) {
                                                subidaLat = coords.first.toString()
                                                subidaLng = coords.second.toString()
                                            }
                                            subidaExtrayendo = false
                                        }
                                    },
                                    enabled = !subidaExtrayendo && subidaMapsLink.isNotBlank(),
                                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Azul),
                                    modifier = Modifier.weight(1f)
                                ) {
                                    if (subidaExtrayendo) {
                                        CircularProgressIndicator(color = Color.White, modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                    } else {
                                        Icon(Icons.Filled.LocationOn, contentDescription = null, tint = Color.White, modifier = Modifier.size(16.dp))
                                    }
                                    Spacer(modifier = Modifier.width(4.dp))
                                    Text("Extraer del Link", color = Color.White, fontSize = 12.sp)
                                }
                                if (subidaNombre.isNotBlank() && subidaCiudad.isNotBlank()) {
                                    OutlinedButton(
                                        onClick = {
                                            geocodificandoSubida = true
                                            scope.launch {
                                                val coords = geocodificarCiudad("$subidaNombre, $subidaCiudad")
                                                if (coords != null) {
                                                    subidaLat = coords.first.toString()
                                                    subidaLng = coords.second.toString()
                                                }
                                                geocodificandoSubida = false
                                            }
                                        },
                                        enabled = !geocodificandoSubida,
                                        modifier = Modifier.weight(1f)
                                    ) {
                                        if (geocodificandoSubida) CircularProgressIndicator(modifier = Modifier.size(16.dp), strokeWidth = 2.dp)
                                        else Text("Buscar por nombre", fontSize = 12.sp)
                                    }
                                }
                            }
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                OutlinedTextField(value = subidaLat, onValueChange = { subidaLat = it }, label = { Text("Latitud") }, singleLine = true, modifier = Modifier.weight(1f))
                                OutlinedTextField(value = subidaLng, onValueChange = { subidaLng = it }, label = { Text("Longitud") }, singleLine = true, modifier = Modifier.weight(1f))
                            }
                            if (subidaLat.isNotBlank() && subidaLng.isNotBlank()) {
                                Text("Coordenadas listas", color = SmartVanColors.Verde, fontSize = 11.sp)
                            }
                            // Reloj digital para horario de salida desde este punto
                            Text("Hora de salida desde este punto:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
                            TimeInput(state = subidaTimePickerState)
                            val isPmSubida = subidaTimePickerState.hour >= 12
                            val displayHourSubida = if (subidaTimePickerState.hour % 12 == 0) 12 else subidaTimePickerState.hour % 12
                            val amPmSubida = if (isPmSubida) "PM" else "AM"
                            val minSubida = subidaTimePickerState.minute.toString().padStart(2, '0')
                            val horaFormateada = "${displayHourSubida.toString().padStart(2, '0')}:$minSubida $amPmSubida"
                            Text("Salida programada: $horaFormateada", color = SmartVanColors.Azul, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                        }
                        "vehiculos" -> {
                            OutlinedTextField(value = vehiculoMarca, onValueChange = { vehiculoMarca = it }, label = { Text("Marca/Tipo (Ej. Sprinter)") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                            OutlinedTextField(value = vehiculoModelo, onValueChange = { vehiculoModelo = it }, label = { Text("Modelo (Ej. 2025)") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                            OutlinedTextField(value = vehiculoPlacas, onValueChange = { vehiculoPlacas = it }, label = { Text("Placas") }, singleLine = true, modifier = Modifier.fillMaxWidth())
                            Spacer(modifier = Modifier.height(12.dp))
                            // Configurador de asientos
                            ConfiguradorAsientos(
                                filasActuales = filasVehiculo,
                                columnas = filasVehiculo.firstOrNull()?.asientos?.size ?: 4,
                                onFilasChange = { filasVehiculo = it }
                            )
                        }
                        "horarios" -> {
                            TimeInput(state = timePickerState)
                        }
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        if (clave == "vehiculos") {
                            // Guardar vehículo con layout completo
                            val nombre = "$vehiculoMarca $vehiculoModelo ($vehiculoPlacas)"
                            val capacidad = filasVehiculo.sumOf { f -> f.asientos.count { it > 0 } }
                            viewModel.guardarVehiculoConfig(VehiculoConfig(
                                nombre = nombre,
                                marca = vehiculoMarca,
                                modelo = vehiculoModelo,
                                placas = vehiculoPlacas,
                                capacidad = capacidad,
                                columnas = filasVehiculo.firstOrNull()?.asientos?.size ?: 4,
                                filas = filasVehiculo,
                            ))
                            categoryToAdd = null
                        } else if (clave == "paradas") {
                            val lat = paradaLat.toDoubleOrNull() ?: 0.0
                            val lng = paradaLng.toDoubleOrNull() ?: 0.0
                            viewModel.guardarParadaConInfo(paradaNombre.trim(), paradaCiudad, lat, lng, listaGuardada, paradaDias)
                            categoryToAdd = null
                        } else if (clave == "puntosSubida") {
                            val lat = subidaLat.toDoubleOrNull() ?: 0.0
                            val lng = subidaLng.toDoubleOrNull() ?: 0.0
                            val isPmS = subidaTimePickerState.hour >= 12
                            val displayHS = if (subidaTimePickerState.hour % 12 == 0) 12 else subidaTimePickerState.hour % 12
                            val amPmS = if (isPmS) "PM" else "AM"
                            val minS = subidaTimePickerState.minute.toString().padStart(2, '0')
                            val horaSubida = "${displayHS.toString().padStart(2, '0')}:$minS $amPmS"
                            viewModel.guardarPuntoSubidaConInfo(subidaNombre.trim(), subidaCiudad, lat, lng, horaSubida, listaGuardada, subidaDias)
                            categoryToAdd = null
                        } else {
                            val valorFinal = when (clave) {
                                "ciudades" -> estadoName.trim()
                                "horarios" -> {
                                    val isPm = timePickerState.hour >= 12
                                    val displayHour = if (timePickerState.hour % 12 == 0) 12 else timePickerState.hour % 12
                                    val amPm = if (isPm) "PM" else "AM"
                                    val min = timePickerState.minute.toString().padStart(2, '0')
                                    "${displayHour.toString().padStart(2, '0')}:$min $amPm"
                                }
                                else -> ""
                            }
                            if (valorFinal.isNotBlank()) {
                                viewModel.agregarDato(clave, valorFinal, listaGuardada)
                            }
                            categoryToAdd = null
                        }
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde)
                ) { Text("Guardar", fontWeight = FontWeight.Bold) }
            },
            dismissButton = {
                TextButton(onClick = { categoryToAdd = null }) { Text("Cancelar", color = Color.Red) }
            }
        )
    }
}

@Composable
fun PreciosYTarifasView(viewModel: AdminViewModel) {
    val precios by viewModel.precios.collectAsState()

    var precioBoleto by remember(precios) { mutableStateOf(precios["base"]?.toString() ?: "350") }
    var precioMaleta by remember(precios) { mutableStateOf(precios["maleta"]?.toString() ?: "150") }
    var precioMascota by remember(precios) { mutableStateOf(precios["mascota"]?.toString() ?: "150") }
    // Recargo por pagar vía Stripe (SPEI/OXXO/tarjeta). No aplica a efectivo ni transferencia manual.
    var costoServicio by remember(precios) {
        mutableStateOf((precios["costoServicio"] ?: CalculoPrecios.COSTO_SERVICIO_STRIPE).toString())
    }

    val hayCambios = (precioBoleto.toIntOrNull() ?: 0) != (precios["base"] ?: 350) ||
            (precioMaleta.toIntOrNull() ?: 0) != (precios["maleta"] ?: 150) ||
            (precioMascota.toIntOrNull() ?: 0) != (precios["mascota"] ?: 150) ||
            (costoServicio.toIntOrNull() ?: -1) != (precios["costoServicio"] ?: CalculoPrecios.COSTO_SERVICIO_STRIPE)

    Column(
        modifier = Modifier.fillMaxSize().padding(16.dp).verticalScroll(rememberScrollState()),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Text("Precios y Tarifas", style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
        Text("Configura los precios que verán los clientes al reservar.", color = Color.Gray, style = MaterialTheme.typography.bodySmall)

        // Precio del boleto
        Card(
            colors = CardDefaults.cardColors(containerColor = Color.White),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(2.dp)
        ) {
            Column(modifier = Modifier.padding(20.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(44.dp).background(SmartVanColors.CyanAccent.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.DirectionsBus, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(24.dp))
                    }
                    Spacer(modifier = Modifier.width(14.dp))
                    Column {
                        Text("Precio del Boleto", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro, style = MaterialTheme.typography.titleMedium)
                        Text("Tarifa base por asiento (sin extras)", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                    }
                }
                Spacer(modifier = Modifier.height(16.dp))
                OutlinedTextField(
                    value = precioBoleto,
                    onValueChange = { if (it.all { c -> c.isDigit() }) precioBoleto = it },
                    label = { Text("Precio en MXN") },
                    leadingIcon = { Text("$", fontWeight = FontWeight.Bold, color = SmartVanColors.CyanAccent, modifier = Modifier.padding(start = 12.dp)) },
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true,
                    shape = RoundedCornerShape(12.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedBorderColor = SmartVanColors.CyanAccent,
                        unfocusedBorderColor = SmartVanColors.Borde,
                        focusedLabelColor = SmartVanColors.CyanAccent,
                        cursorColor = SmartVanColors.CyanAccent
                    )
                )
                Spacer(modifier = Modifier.height(8.dp))
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoCyan),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Text(
                        "Este es el precio que se muestra al cliente por cada asiento seleccionado.",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color(0xFF006064),
                        modifier = Modifier.padding(10.dp)
                    )
                }
            }
        }

        // Extras
        Card(
            colors = CardDefaults.cardColors(containerColor = Color.White),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(2.dp)
        ) {
            Column(modifier = Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(44.dp).background(SmartVanColors.Naranja.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.Settings, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(24.dp))
                    }
                    Spacer(modifier = Modifier.width(14.dp))
                    Column {
                        Text("Servicios Adicionales", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro, style = MaterialTheme.typography.titleMedium)
                        Text("Cargos extra por maleta y mascota", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                    }
                }

                HorizontalDivider(color = SmartVanColors.FondoGris)

                // Maleta
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    Box(
                        modifier = Modifier.size(36.dp).background(SmartVanColors.Purpura.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.DateRange, contentDescription = null, tint = SmartVanColors.Purpura, modifier = Modifier.size(18.dp))
                    }
                    Column(modifier = Modifier.weight(1f)) {
                        Text("Maleta Extra", fontWeight = FontWeight.Bold, color = Color.DarkGray)
                        Text("Cargo por cada maleta adicional", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                    }
                    OutlinedTextField(
                        value = precioMaleta,
                        onValueChange = { if (it.all { c -> c.isDigit() }) precioMaleta = it },
                        leadingIcon = { Text("$", fontWeight = FontWeight.Bold, color = SmartVanColors.Purpura, modifier = Modifier.padding(start = 8.dp)) },
                        modifier = Modifier.width(120.dp),
                        singleLine = true,
                        shape = RoundedCornerShape(10.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedBorderColor = SmartVanColors.Purpura,
                            unfocusedBorderColor = SmartVanColors.Borde,
                            cursorColor = SmartVanColors.Purpura
                        )
                    )
                }

                HorizontalDivider(color = SmartVanColors.FondoGris)

                // Mascota
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    Box(
                        modifier = Modifier.size(36.dp).background(SmartVanColors.Verde.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.EmojiEvents, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(18.dp))
                    }
                    Column(modifier = Modifier.weight(1f)) {
                        Text("Mascota a Bordo", fontWeight = FontWeight.Bold, color = Color.DarkGray)
                        Text("Cargo por llevar mascota", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                    }
                    OutlinedTextField(
                        value = precioMascota,
                        onValueChange = { if (it.all { c -> c.isDigit() }) precioMascota = it },
                        leadingIcon = { Text("$", fontWeight = FontWeight.Bold, color = SmartVanColors.Verde, modifier = Modifier.padding(start = 8.dp)) },
                        modifier = Modifier.width(120.dp),
                        singleLine = true,
                        shape = RoundedCornerShape(10.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedBorderColor = SmartVanColors.Verde,
                            unfocusedBorderColor = SmartVanColors.Borde,
                            cursorColor = SmartVanColors.Verde
                        )
                    )
                }
            }
        }

        // Costo por servicio (recargo Stripe)
        Card(
            colors = CardDefaults.cardColors(containerColor = Color.White),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(2.dp)
        ) {
            Column(modifier = Modifier.padding(20.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(44.dp).background(SmartVanColors.Amarillo.copy(alpha = 0.15f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.Payments, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(24.dp))
                    }
                    Spacer(modifier = Modifier.width(14.dp))
                    Column {
                        Text("Costo por Servicio", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro, style = MaterialTheme.typography.titleMedium)
                        Text("Recargo al pagar con tarjeta, SPEI u OXXO", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                    }
                }
                Spacer(modifier = Modifier.height(16.dp))
                OutlinedTextField(
                    value = costoServicio,
                    onValueChange = { if (it.all { c -> c.isDigit() } && it.length <= 4) costoServicio = it },
                    label = { Text("Recargo en MXN") },
                    leadingIcon = { Text("$", fontWeight = FontWeight.Bold, color = SmartVanColors.Naranja, modifier = Modifier.padding(start = 12.dp)) },
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true,
                    shape = RoundedCornerShape(12.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedBorderColor = SmartVanColors.Naranja,
                        unfocusedBorderColor = SmartVanColors.Borde,
                        focusedLabelColor = SmartVanColors.Naranja,
                        cursorColor = SmartVanColors.Naranja
                    )
                )
                Spacer(modifier = Modifier.height(8.dp))
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoNaranja),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Column(modifier = Modifier.padding(10.dp)) {
                        Text(
                            "Cubre la comisión que cobra Stripe por procesar el pago. Se suma al total solo cuando el cliente paga con tarjeta, SPEI u OXXO.",
                            style = MaterialTheme.typography.labelSmall,
                            color = SmartVanColors.NaranjaDeep
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            "En efectivo y transferencia directa NO se cobra (el dinero llega sin comisión). Ponlo en 0 para dejar de cobrarlo.",
                            style = MaterialTheme.typography.labelSmall,
                            color = SmartVanColors.NaranjaDeep
                        )
                    }
                }
            }
        }

        // Preview card
        Card(
            colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoPanel),
            shape = RoundedCornerShape(16.dp),
            border = BorderStroke(1.dp, SmartVanColors.Borde)
        ) {
            Column(modifier = Modifier.padding(20.dp)) {
                Text("Vista Previa del Cliente", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro, modifier = Modifier.padding(bottom = 12.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("1 Boleto (base)", color = Color.DarkGray)
                    Text("$${precioBoleto.toIntOrNull() ?: 0} MXN", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("+ 1 Maleta extra", color = Color.DarkGray)
                    Text("$${precioMaleta.toIntOrNull() ?: 0} MXN", fontWeight = FontWeight.Bold, color = SmartVanColors.Purpura)
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("+ Mascota", color = Color.DarkGray)
                    Text("$${precioMascota.toIntOrNull() ?: 0} MXN", fontWeight = FontWeight.Bold, color = SmartVanColors.Verde)
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("+ Costo por servicio (solo Stripe)", color = Color.DarkGray)
                    Text("$${costoServicio.toIntOrNull() ?: 0} MXN", fontWeight = FontWeight.Bold, color = SmartVanColors.Naranja)
                }
                HorizontalDivider(modifier = Modifier.padding(vertical = 8.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("Total con tarjeta:", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
                    val totalEjemplo = (precioBoleto.toIntOrNull() ?: 0) + (precioMaleta.toIntOrNull() ?: 0) +
                            (precioMascota.toIntOrNull() ?: 0) + (costoServicio.toIntOrNull() ?: 0)
                    Text("$$totalEjemplo MXN", fontWeight = FontWeight.Black, color = SmartVanColors.CyanAccent, style = MaterialTheme.typography.titleMedium)
                }
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text("Total en efectivo:", fontWeight = FontWeight.Bold, color = Color.Gray, style = MaterialTheme.typography.bodySmall)
                    val totalEfectivo = (precioBoleto.toIntOrNull() ?: 0) + (precioMaleta.toIntOrNull() ?: 0) + (precioMascota.toIntOrNull() ?: 0)
                    Text("$$totalEfectivo MXN", fontWeight = FontWeight.Bold, color = Color.Gray, style = MaterialTheme.typography.bodySmall)
                }
            }
        }

        // Save button
        Button(
            onClick = {
                val nuevos = mapOf(
                    "base" to (precioBoleto.toIntOrNull() ?: 350),
                    "maleta" to (precioMaleta.toIntOrNull() ?: 150),
                    "mascota" to (precioMascota.toIntOrNull() ?: 150),
                    "costoServicio" to (costoServicio.toIntOrNull() ?: CalculoPrecios.COSTO_SERVICIO_STRIPE)
                )
                viewModel.guardarPrecios(nuevos)
            },
            modifier = Modifier.fillMaxWidth().height(52.dp),
            enabled = hayCambios && (precioBoleto.toIntOrNull() ?: 0) > 0,
            colors = ButtonDefaults.buttonColors(
                containerColor = SmartVanColors.AzulOscuro,
                disabledContainerColor = Color.LightGray
            ),
            shape = RoundedCornerShape(14.dp)
        ) {
            Text("Guardar Cambios", fontWeight = FontWeight.Bold, color = Color.White)
        }

        if (!hayCambios) {
            Text(
                "Los precios están sincronizados con la base de datos.",
                style = MaterialTheme.typography.labelSmall,
                color = SmartVanColors.Verde,
                modifier = Modifier.align(Alignment.CenterHorizontally)
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AdminDropdown(label: String, options: List<String>, selected: String, onSelect: (String) -> Unit, modifier: Modifier = Modifier) {
    var expanded by remember { mutableStateOf(false) }
    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = { expanded = it },
        modifier = modifier
    ) {
        OutlinedTextField(
            value = selected.ifEmpty { "Seleccionar..." },
            onValueChange = {}, readOnly = true, label = { Text(label) },
            modifier = Modifier.fillMaxWidth().menuAnchor(),
            trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expanded) }
        )
        ExposedDropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            options.forEach { opt ->
                DropdownMenuItem(
                    text = { Text(opt, fontWeight = FontWeight.Medium) },
                    onClick = { onSelect(opt); expanded = false },
                    contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding
                )
            }
        }
    }
}

@Composable
fun ReportCard(modifier: Modifier, title: String, amount: Int, color: Color, icon: @Composable () -> Unit = {}, suffix: String = "MXN") {
    Card(
        modifier = modifier,
        colors = CardDefaults.cardColors(containerColor = color.copy(alpha = 0.08f)),
        shape = RoundedCornerShape(16.dp),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(title, style = MaterialTheme.typography.labelSmall, color = color, fontWeight = FontWeight.SemiBold)
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(color.copy(alpha = 0.15f), CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    icon()
                }
            }
            Spacer(modifier = Modifier.height(8.dp))
            val displayText = if (suffix == "MXN") "$$amount MXN" else "$amount $suffix"
            Text(displayText, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Black, color = color)
        }
    }
}
@Composable
fun GraficaIngresosSimple(reservas: List<Boleto>) {
    val datosGrafica = reservas.groupBy { it.fechaViaje }
        .mapValues { it.value.sumOf { b -> b.totalPagado } }
        .toList()
        .sortedBy { it.first }

    val maxMonto = datosGrafica.maxOfOrNull { it.second } ?: 1

    Card(
        modifier = Modifier.fillMaxWidth().padding(vertical = 16.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        shape = RoundedCornerShape(16.dp),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(modifier = Modifier.padding(20.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column {
                    Text("Desempeño por Día", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                    Text("Ingresos del rango seleccionado", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                }
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(SmartVanColors.CyanAccent.copy(alpha = 0.1f), CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(20.dp))
                }
            }
            Spacer(modifier = Modifier.height(20.dp))

            Row(
                modifier = Modifier.height(160.dp).fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                datosGrafica.forEach { (fecha, monto) ->
                    val alturaProporcional = if (monto > 0) (monto.toFloat() / maxMonto).coerceIn(0.08f, 1f) else 0.08f
                    val alturaExacta = (150 * alturaProporcional).dp
                    val barColor = if (monto == maxMonto) SmartVanColors.CyanAccent else SmartVanColors.AzulOscuro

                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.weight(1f)) {
                        Text(
                            "$${monto}",
                            style = MaterialTheme.typography.labelSmall,
                            color = barColor,
                            fontWeight = if (monto == maxMonto) FontWeight.Bold else FontWeight.Normal,
                            fontSize = 9.sp
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Box(
                            modifier = Modifier
                                .fillMaxWidth(0.7f)
                                .height(alturaExacta)
                                .background(
                                    barColor,
                                    RoundedCornerShape(topStart = 6.dp, topEnd = 6.dp)
                                )
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            fecha.takeLast(5),
                            style = MaterialTheme.typography.labelSmall,
                            fontSize = 9.sp,
                            color = Color.Gray
                        )
                    }
                }
            }
        }
    }
}
@Composable
fun AdminBookingCard(boleto: Boleto) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        shape = RoundedCornerShape(14.dp),
        elevation = CardDefaults.cardElevation(defaultElevation = 1.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier
                            .size(32.dp)
                            .background(SmartVanColors.CyanAccent.copy(alpha = 0.1f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(Icons.Filled.Email, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Column {
                        Text(
                            boleto.origenDestino,
                            fontWeight = FontWeight.Bold,
                            color = SmartVanColors.AzulOscuro,
                            style = MaterialTheme.typography.bodyMedium
                        )
                        Text(
                            "ID: ${boleto.timestamp.toString().takeLast(6)}",
                            style = MaterialTheme.typography.labelSmall,
                            color = Color.Gray
                        )
                    }
                }
                Box(
                    modifier = Modifier
                        .background(SmartVanColors.Verde.copy(alpha = 0.1f), RoundedCornerShape(20.dp))
                        .padding(horizontal = 10.dp, vertical = 4.dp)
                ) {
                    Text("$${boleto.totalPagado} MXN", fontWeight = FontWeight.Bold, color = SmartVanColors.Verde, fontSize = 12.sp)
                }
            }
            HorizontalDivider(modifier = Modifier.padding(vertical = 10.dp), color = SmartVanColors.FondoGris)
            boleto.pasajeros.forEach { p ->
                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(vertical = 2.dp)) {
                    Icon(Icons.Filled.AccountCircle, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(6.dp))
                    Text(
                        "Asiento ${p.asiento} — ${p.nombre}",
                        style = MaterialTheme.typography.bodySmall,
                        color = Color.DarkGray
                    )
                    if (p.telefono.isNotBlank()) {
                        Text(
                            "  •  ${p.telefono}",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color.Gray
                        )
                    }
                }
            }
        }
    }
}

/** Convierte "YYYY-MM-DD" a día epoch (algoritmo civil de Howard Hinnant). Multiplataforma. */
internal fun fechaAEpochDay(fecha: String): Long {
    val p = fecha.split("-")
    if (p.size != 3) return 0
    val y = p[0].toIntOrNull() ?: return 0
    val m = p[1].toIntOrNull() ?: return 0
    val d = p[2].toIntOrNull() ?: return 0
    val yy = if (m <= 2) y - 1 else y
    val era = (if (yy >= 0) yy else yy - 399) / 400
    val yoe = (yy - era * 400).toLong()              // [0, 399]
    val mp = (m + 9) % 12                              // mar=0 .. feb=11
    val doy = (153 * mp + 2) / 5 + d - 1               // [0, 365]
    val doe = yoe * 365 + yoe / 4 - yoe / 100 + doy    // [0, 146096]
    return era.toLong() * 146097 + doe - 719468
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ViajesPublicadosView(viewModel: AdminViewModel) {
    var fechaSeleccionada by remember { mutableStateOf(org.example.abigail.obtenerFechaHoy()) }
    val itinerarios by viewModel.itinerarios.collectAsState()
    var busqueda by remember { mutableStateOf("") }
    var rangoDias by remember { mutableStateOf(7) } // 7, 15, 0 = todos
    var soloIncompletos by remember { mutableStateOf(false) }
    val hoy = org.example.abigail.obtenerFechaHoy()
    val diaHoy = fechaAEpochDay(hoy)
    val diaLimite = if (rangoDias <= 0) Long.MAX_VALUE else diaHoy + rangoDias
    val viajesFiltrados = itinerarios
        .filter { val d = fechaAEpochDay(it.fecha); d in diaHoy..diaLimite }
        .filter { v ->
            busqueda.isBlank() ||
                v.ruta.contains(busqueda, ignoreCase = true) ||
                v.chofer.contains(busqueda, ignoreCase = true) ||
                v.vehiculo.contains(busqueda, ignoreCase = true)
        }
        .filter { v ->
            !soloIncompletos ||
                v.chofer.isBlank() || v.chofer == "Sin asignar" ||
                v.vehiculo.isBlank() || v.vehiculo == "Sin asignar"
        }
        .sortedWith(compareBy({ it.fecha }, { it.ruta }, { it.horario }))
    var mostrarDialogo by remember { mutableStateOf(false) }
    var rutaSeleccionada by remember { mutableStateOf("") }
    var horarioSeleccionado by remember { mutableStateOf("") }
    var asientosVendidos by remember { mutableStateOf(0) }
    var estaCargandoAsientos by remember { mutableStateOf(false) }
    var mostrarDialogoReasignacion by remember { mutableStateOf(false) }
    val choferesDisponibles by viewModel.choferes.collectAsState()
    val vehiculosDisponibles by viewModel.vehiculos.collectAsState()
    val mensajeReasignacion by viewModel.mensajeReasignacion.collectAsState()

    val scope = rememberCoroutineScope()
    LaunchedEffect(Unit) {
        viewModel.cargarItinerarios()
    }

    Column(modifier = Modifier.fillMaxSize().padding(16.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column {
                Text(
                    "Viajes Publicados",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Black
                )
                Text(
                    "Lista de viajes de los próximos días con ocupación y asignaciones.",
                    color = Color.Gray
                )
            }
            TextButton(onClick = { viewModel.cargarItinerarios() }) {
                Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                Spacer(modifier = Modifier.width(4.dp))
                Text("Refrescar", color = SmartVanColors.CyanAccent, fontSize = 12.sp)
            }
        }
        Spacer(modifier = Modifier.height(8.dp))
        OutlinedButton(
            onClick = { mostrarDialogoReasignacion = true },
            modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp),
            border = BorderStroke(1.dp, Color.Red),
            colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red)
        ) {
            Text("Reasignación Masiva (Emergencias)", fontWeight = FontWeight.Bold)
        }

        // --- Filtros ---
        OutlinedTextField(
            value = busqueda,
            onValueChange = { busqueda = it },
            modifier = Modifier.fillMaxWidth(),
            placeholder = { Text("Buscar por ruta, chofer o vehículo...") },
            leadingIcon = { Icon(Icons.Filled.Search, contentDescription = null, tint = Color.Gray) },
            shape = RoundedCornerShape(12.dp),
            singleLine = true
        )
        Spacer(modifier = Modifier.height(8.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            FilterChip(selected = rangoDias == 7, onClick = { rangoDias = 7 }, label = { Text("7 días") })
            FilterChip(selected = rangoDias == 15, onClick = { rangoDias = 15 }, label = { Text("15 días") })
            FilterChip(selected = rangoDias == 0, onClick = { rangoDias = 0 }, label = { Text("Todos") })
            Spacer(modifier = Modifier.weight(1f))
            FilterChip(
                selected = soloIncompletos,
                onClick = { soloIncompletos = !soloIncompletos },
                label = { Text("Incompletos") },
                leadingIcon = if (soloIncompletos) {
                    { Icon(Icons.Filled.Check, contentDescription = null, modifier = Modifier.size(16.dp)) }
                } else null
            )
        }
        Spacer(modifier = Modifier.height(8.dp))
        Text("${viajesFiltrados.size} viaje(s) en el rango seleccionado", color = Color.Gray, style = MaterialTheme.typography.bodySmall)
        Spacer(modifier = Modifier.height(8.dp))
        HorizontalDivider()
        Spacer(modifier = Modifier.height(12.dp))

        if (viajesFiltrados.isEmpty()) {
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                Text("No hay viajes con estos filtros.", color = Color.Gray)
            }
        } else {
            LazyColumn(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                viajesFiltrados.groupBy { it.fecha }.forEach { (fecha, viajesDia) ->
                    item(key = "hdr_$fecha") {
                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(top = 8.dp)) {
                            Icon(Icons.Filled.CalendarMonth, contentDescription = null, tint = SmartVanColors.AzulOscuro, modifier = Modifier.size(18.dp))
                            Spacer(modifier = Modifier.width(6.dp))
                            Text(fecha, fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
                            Spacer(modifier = Modifier.width(8.dp))
                            Text("${viajesDia.size} viaje(s)", color = Color.Gray, fontSize = 12.sp)
                        }
                    }
                    items(viajesDia, key = { "${it.ruta}_${it.fecha}_${it.horario}" }) { viaje ->
                        val tieneChofer = viaje.chofer.isNotBlank() && viaje.chofer != "Sin asignar"
                        val tieneVehiculo = viaje.vehiculo.isNotBlank() && viaje.vehiculo != "Sin asignar"
                        val estadoCompleto = tieneChofer && tieneVehiculo
                        val partesRuta = viaje.ruta.split(" - ", " – ", "-").map { it.trim() }.filter { it.isNotBlank() }
                        val origen = partesRuta.getOrNull(0) ?: viaje.ruta
                        val destino = partesRuta.getOrNull(1) ?: ""

                        Card(
                            colors = CardDefaults.cardColors(containerColor = Color.White),
                            elevation = CardDefaults.cardElevation(2.dp),
                            shape = RoundedCornerShape(14.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Column(modifier = Modifier.padding(16.dp)) {
                                // Ruta origen → destino + estado
                                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                                        Icon(Icons.Filled.Place, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(18.dp))
                                        Spacer(modifier = Modifier.width(4.dp))
                                        Text(origen, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                                        if (destino.isNotBlank()) {
                                            Icon(Icons.Filled.ArrowForward, contentDescription = null, tint = Color.Gray, modifier = Modifier.size(16.dp).padding(horizontal = 2.dp))
                                            Text(destino, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                                        }
                                    }
                                    Box(
                                        modifier = Modifier.background(
                                            if (estadoCompleto) SmartVanColors.Verde.copy(alpha = 0.1f) else SmartVanColors.Naranja.copy(alpha = 0.1f),
                                            RoundedCornerShape(20.dp)
                                        ).padding(horizontal = 10.dp, vertical = 4.dp)
                                    ) {
                                        Text(
                                            if (estadoCompleto) "Listo" else "Incompleto",
                                            color = if (estadoCompleto) SmartVanColors.Verde else SmartVanColors.Naranja,
                                            fontWeight = FontWeight.Bold, fontSize = 11.sp
                                        )
                                    }
                                }
                                Spacer(modifier = Modifier.height(8.dp))
                                // Horario
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.AzulOscuro, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text(viaje.horario, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro, style = MaterialTheme.typography.bodyMedium)
                                }
                                Spacer(modifier = Modifier.height(6.dp))
                                // Boletos vendidos / ocupación
                                val cap = viaje.capacidad
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.ConfirmationNumber, contentDescription = null, tint = SmartVanColors.VerdeOscuro, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text(
                                        if (cap > 0) "${viaje.vendidos} / $cap vendidos  ·  ${viaje.disponibles} libre(s)"
                                        else "${viaje.vendidos} vendido(s)",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = if (cap > 0 && viaje.disponibles == 0) Color.Red else Color.DarkGray,
                                        fontWeight = FontWeight.SemiBold
                                    )
                                }
                                Spacer(modifier = Modifier.height(8.dp))
                                // Chofer
                                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(bottom = 4.dp)) {
                                    Icon(Icons.Filled.AccountCircle, contentDescription = null, tint = if (tieneChofer) SmartVanColors.CyanAccent else Color.LightGray, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text(
                                        if (tieneChofer) viaje.chofer else "Sin chofer asignado",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = if (tieneChofer) Color.DarkGray else Color.Red,
                                        fontWeight = if (!tieneChofer) FontWeight.SemiBold else FontWeight.Normal
                                    )
                                }
                                // Vehículo
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Map, contentDescription = null, tint = if (tieneVehiculo) SmartVanColors.CyanAccent else Color.LightGray, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text(
                                        if (tieneVehiculo) viaje.vehiculo else "Sin vehículo asignado",
                                        style = MaterialTheme.typography.bodySmall,
                                        color = if (tieneVehiculo) Color.DarkGray else Color.Red,
                                        fontWeight = if (!tieneVehiculo) FontWeight.SemiBold else FontWeight.Normal
                                    )
                                }
                                // Botón cancelar compacto, alineado abajo-derecha
                                Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp), horizontalArrangement = Arrangement.End) {
                                    OutlinedButton(
                                        onClick = {
                                            rutaSeleccionada = viaje.ruta
                                            fechaSeleccionada = viaje.fecha
                                            horarioSeleccionado = viaje.horario
                                            mostrarDialogo = true
                                            estaCargandoAsientos = true
                                            scope.launch {
                                                asientosVendidos = viewModel.verificarAsientosVendidos(viaje.ruta, viaje.fecha, viaje.horario)
                                                estaCargandoAsientos = false
                                            }
                                        },
                                        colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red),
                                        border = BorderStroke(1.dp, Color.Red.copy(alpha = 0.6f)),
                                        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 4.dp),
                                        modifier = Modifier.height(34.dp)
                                    ) {
                                        Icon(Icons.Filled.Cancel, contentDescription = null, modifier = Modifier.size(15.dp))
                                        Spacer(modifier = Modifier.width(4.dp))
                                        Text("Cancelar", color = Color.Red, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    if (mostrarDialogo) {
        AlertDialog(
            onDismissRequest = { mostrarDialogo = false },
            title = {
                Text("Confirmar Cancelación", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
            },
            text = {
                Column {
                    Text("¿Estás completamente seguro de que deseas eliminar este viaje del sistema?")
                    Spacer(modifier = Modifier.height(12.dp))

                    if (estaCargandoAsientos) {
                        Text("Verificando boletos vendidos...", color = Color.Gray, fontStyle = FontStyle.Italic)
                    } else if (asientosVendidos > 0) {
                        Card(colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoRojo)) {
                            Column(modifier = Modifier.padding(12.dp)) {
                                Text("¡ALTO AHÍ!", color = Color.Red, fontWeight = FontWeight.Black)
                                Text("Este viaje ya tiene $asientosVendidos asiento(s) vendido(s).", color = Color.Red, fontWeight = FontWeight.Bold)
                                Spacer(modifier = Modifier.height(4.dp))
                                Text("Si cancelas, tendrás que gestionar reprogramaciones o reembolsos manualmente.", style = MaterialTheme.typography.bodySmall)
                            }
                        }
                    } else {
                        Text("No hay asientos vendidos. Puedes cancelar sin afectaciones.", color = SmartVanColors.Verde, fontWeight = FontWeight.Bold)
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        viewModel.cancelarViaje(rutaSeleccionada, fechaSeleccionada, horarioSeleccionado)
                        mostrarDialogo = false
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Red)
                ) {
                    Text("Sí, Cancelar Definitivamente")
                }
            },
            dismissButton = {
                TextButton(onClick = { mostrarDialogo = false }) {
                    Text("Regresar")
                }
            }
        )
    }
    if (mostrarDialogoReasignacion) {
        var choferSale by remember { mutableStateOf("") }
        var choferEntra by remember { mutableStateOf("") }
        var vehiculoNuevo by remember { mutableStateOf("") }

        AlertDialog(
            onDismissRequest = { mostrarDialogoReasignacion = false },
            title = { Text("Traspaso de Logística", fontWeight = FontWeight.Black, color = Color.Red) },
            text = {
                Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    Text("Esta herramienta transferirá TODOS los viajes futuros del chofer saliente al nuevo chofer de forma inmediata.", color = Color.Gray, style = MaterialTheme.typography.bodySmall)

                    AdminDropdown("Chofer Saliente (Baja/Falta)", choferesDisponibles, choferSale, { choferSale = it }, Modifier.fillMaxWidth())

                    HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))

                    AdminDropdown("Chofer Entrante (Reemplazo)", choferesDisponibles.filter { it != choferSale }, choferEntra, { choferEntra = it }, Modifier.fillMaxWidth())
                    AdminDropdown("Vehículo Asignado", vehiculosDisponibles, vehiculoNuevo, { vehiculoNuevo = it }, Modifier.fillMaxWidth())
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        viewModel.ejecutarReasignacionMasiva(choferSale, choferEntra, vehiculoNuevo)
                        mostrarDialogoReasignacion = false
                    },
                    enabled = choferSale.isNotBlank() && choferEntra.isNotBlank() && vehiculoNuevo.isNotBlank(),
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Red)
                ) { Text("Ejecutar Traspaso") }
            },
            dismissButton = {
                TextButton(onClick = { mostrarDialogoReasignacion = false }) { Text("Cancelar") }
            }
        )
    }
    mensajeReasignacion?.let { msg ->
        AlertDialog(
            onDismissRequest = { viewModel.limpiarMensajeReasignacion() },
            title = { Text("Reporte del Sistema", fontWeight = FontWeight.Bold) },
            text = { Text(msg) },
            confirmButton = {
                Button(onClick = { viewModel.limpiarMensajeReasignacion() }, colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)) {
                    Text("Entendido")
                }
            }
        )
    }
}
@Composable
fun AdministrarCuentasView(viewModel: AdminViewModel, miRolActual: String) {
    val usuarios by viewModel.usuariosRegistrados.collectAsState()
    val resetResult by viewModel.resetResult.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.cargarUsuarios()
    }

    // Dialog showing temp password
    resetResult?.let { (nombre, tempPass) ->
        AlertDialog(
            onDismissRequest = { viewModel.limpiarResetResult() },
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        if (tempPass == "ERROR") Icons.Filled.Cancel else Icons.Filled.Key,
                        contentDescription = null,
                        tint = if (tempPass == "ERROR") Color.Red else SmartVanColors.Verde,
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        if (tempPass == "ERROR") "Error" else "Contraseña Restablecida",
                        fontWeight = FontWeight.Black,
                        color = SmartVanColors.AzulOscuro
                    )
                }
            },
            text = {
                if (tempPass == "ERROR") {
                    Text("No se pudo restablecer la contraseña. Verifica los permisos o intenta de nuevo.")
                } else {
                    Column {
                        Text("Se generó una contraseña temporal para ${nombre.uppercase()}.")
                        Spacer(modifier = Modifier.height(12.dp))
                        Card(
                            colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoNaranja),
                            shape = RoundedCornerShape(10.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Column(modifier = Modifier.padding(16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
                                Text("Contraseña Temporal", style = MaterialTheme.typography.labelSmall, color = SmartVanColors.Naranja)
                                Spacer(modifier = Modifier.height(4.dp))
                                Text(
                                    tempPass,
                                    style = MaterialTheme.typography.headlineSmall,
                                    fontWeight = FontWeight.Black,
                                    color = SmartVanColors.AzulOscuro,
                                    letterSpacing = 2.sp
                                )
                            }
                        }
                        Spacer(modifier = Modifier.height(12.dp))
                        Text(
                            "Comunícasela al usuario. Al iniciar sesión se le pedirá que establezca una nueva contraseña.",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color.Gray
                        )
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = { viewModel.limpiarResetResult() },
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)
                ) {
                    Text("Entendido")
                }
            }
        )
    }


    Column(modifier = Modifier.fillMaxSize().padding(16.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text("Administrar Cuentas", style = MaterialTheme.typography.headlineMedium, fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
                Text("Supervisa los roles y accesos de los usuarios registrados.", color = Color.Gray)
            }
            TextButton(onClick = { viewModel.cargarUsuarios() }) {
                Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                Spacer(modifier = Modifier.width(4.dp))
                Text("Refrescar", color = SmartVanColors.CyanAccent, fontSize = 12.sp)
            }
        }
        Spacer(modifier = Modifier.height(8.dp))

        // Puede gestionar cuentas (crear/editar rol/resetear contraseña/eliminar).
        // Incluye 'desarrollador' porque está por encima de master (rango 120).
        val esAdminGeneral = miRolActual == "admin_general" || miRolActual == "desarrollador"
        var busquedaCuentas by remember { mutableStateOf("") }
        var filtroRol by remember { mutableStateOf("Todos") }
        var mostrarConfirmEliminar by remember { mutableStateOf<UsuarioApp?>(null) }
        var mostrarFormCrear by remember { mutableStateOf(false) }
        var nuevoEmail by remember { mutableStateOf("") }
        var nuevoPassword by remember { mutableStateOf("") }
        var nuevoNombre by remember { mutableStateOf("") }
        var nuevoRol by remember { mutableStateOf("chofer") }

        if (esAdminGeneral) {
            Button(
                onClick = { mostrarFormCrear = !mostrarFormCrear },
                modifier = Modifier.fillMaxWidth(),
                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro),
                shape = RoundedCornerShape(10.dp)
            ) {
                Icon(Icons.Filled.PersonAdd, contentDescription = null, tint = Color.White)
                Spacer(modifier = Modifier.width(8.dp))
                Text(if (mostrarFormCrear) "Cerrar formulario" else "Crear nueva cuenta", color = Color.White, fontWeight = FontWeight.Bold)
            }

            if (mostrarFormCrear) {
                Spacer(modifier = Modifier.height(8.dp))
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoPanel),
                    shape = RoundedCornerShape(12.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Column(modifier = Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        Text("Nueva Cuenta", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                        OutlinedTextField(value = nuevoNombre, onValueChange = { nuevoNombre = it }, label = { Text("Nombre completo") }, modifier = Modifier.fillMaxWidth(), singleLine = true)
                        OutlinedTextField(value = nuevoEmail, onValueChange = { nuevoEmail = it }, label = { Text("Correo electrónico") }, modifier = Modifier.fillMaxWidth(), singleLine = true)
                        OutlinedTextField(value = nuevoPassword, onValueChange = { nuevoPassword = it }, label = { Text("Contraseña (mín. 6 caracteres)") }, modifier = Modifier.fillMaxWidth(), singleLine = true)
                        Text("Rol:", fontWeight = FontWeight.Bold, fontSize = 13.sp)
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            listOf("chofer", "chofer_admin", "admin").forEach { rol ->
                                FilterChip(selected = nuevoRol == rol, onClick = { nuevoRol = rol }, label = { Text(rol.uppercase().replace("_", " "), fontSize = 12.sp) })
                            }
                        }
                        Button(
                            onClick = {
                                if (nuevoEmail.isNotBlank() && nuevoPassword.length >= 6 && nuevoNombre.isNotBlank()) {
                                    viewModel.crearCuenta(nuevoEmail, nuevoPassword, nuevoNombre, nuevoRol)
                                    nuevoEmail = ""; nuevoPassword = ""; nuevoNombre = ""; nuevoRol = "chofer"
                                    mostrarFormCrear = false
                                }
                            },
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                            enabled = nuevoEmail.isNotBlank() && nuevoPassword.length >= 6 && nuevoNombre.isNotBlank()
                        ) { Text("Crear Cuenta", fontWeight = FontWeight.Bold) }
                    }
                }
            }
            Spacer(modifier = Modifier.height(12.dp))
        }

        // Search and filter
        OutlinedTextField(
            value = busquedaCuentas,
            onValueChange = { busquedaCuentas = it },
            label = { Text("Buscar por nombre o correo") },
            leadingIcon = { Icon(Icons.Filled.People, contentDescription = null, tint = Color.Gray, modifier = Modifier.size(20.dp)) },
            modifier = Modifier.fillMaxWidth(),
            singleLine = true,
            shape = RoundedCornerShape(12.dp),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = SmartVanColors.CyanAccent,
                unfocusedBorderColor = SmartVanColors.Borde,
                focusedLabelColor = SmartVanColors.CyanAccent,
                cursorColor = SmartVanColors.CyanAccent
            )
        )
        Spacer(modifier = Modifier.height(8.dp))
        // LazyRow: los chips de rol se desplazan horizontal en vez de deformarse cuando no caben.
        CarruselHorizontal(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            items(listOf("Todos", "chofer", "chofer_admin", "admin", "admin_general", "master", "desarrollador")) { rol ->
                FilterChip(
                    selected = filtroRol == rol,
                    onClick = { filtroRol = rol },
                    label = { Text(rol.uppercase().replace("_", " "), fontSize = 11.sp, maxLines = 1) },
                    colors = FilterChipDefaults.filterChipColors(
                        selectedContainerColor = SmartVanColors.AzulOscuro,
                        selectedLabelColor = Color.White
                    )
                )
            }
        }
        Spacer(modifier = Modifier.height(12.dp))

        val usuariosFiltrados = usuarios.filter { user ->
            val visiblePorRol = when {
                // Solo desarrollador puede ver/gestionar cuentas de rango >= master.
                user.rol == "desarrollador" -> miRolActual == "desarrollador"
                user.rol == "master" -> miRolActual == "desarrollador"
                user.rol == "admin_general" -> esAdminGeneral
                else -> true
            }
            val coincideBusqueda = busquedaCuentas.isBlank() ||
                user.nombre.contains(busquedaCuentas, ignoreCase = true) ||
                user.correo.contains(busquedaCuentas, ignoreCase = true)
            // Match EXACTO: filtrar "chofer" ya no incluía "chofer_admin".
            val coincideFiltro = filtroRol == "Todos" || user.rol == filtroRol
            visiblePorRol && coincideBusqueda && coincideFiltro
        }

        if (usuariosFiltrados.isEmpty()) {
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                Text("Cargando usuarios...", color = Color.Gray)
            }
        } else {
            LazyColumn(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                items(usuariosFiltrados) { user ->
                    val hayPeticionPendiente = user.rolSolicitado != null
                    val tienePermisoParaEditar = (miRolActual == "desarrollador" && user.rol != "desarrollador") ||
                            (miRolActual == "master" && user.rol != "master" && user.rol != "desarrollador") ||
                            (miRolActual == "admin_general" && user.rol != "admin_general" && user.rol != "master" && user.rol != "desarrollador") ||
                            (miRolActual == "admin" && user.rol != "admin_general" && user.rol != "admin" && user.rol != "master" && user.rol != "desarrollador")
                    // Sistema uni-desarrollador: el rol 'desarrollador' NO aparece en los dropdowns
                    // de ningún operador. Ver reglas RTDB (.validate de usuarios/$uid/rol) que
                    // bloquea escribir 'desarrollador' desde la app; solo Firebase Console.
                    val opcionesBase = when (miRolActual) {
                        "desarrollador" -> listOf("chofer", "chofer_admin", "admin", "admin_general", "master")
                        "master" -> listOf("chofer", "chofer_admin", "admin", "admin_general")
                        "admin_general" -> listOf("chofer", "chofer_admin", "admin")
                        else -> listOf("chofer", "chofer_admin")
                    }
                    val opcionesDeRol = opcionesBase.filter { it != user.rol }
                    var showMenu by remember { mutableStateOf(false) }
                    var rolAConfirmar by remember { mutableStateOf<String?>(null) }
                    val scope = rememberCoroutineScope()

                    Card(
                        colors = CardDefaults.cardColors(containerColor = if (hayPeticionPendiente) SmartVanColors.FondoNaranja else Color.White),
                        elevation = CardDefaults.cardElevation(2.dp),
                        modifier = Modifier.fillMaxWidth().clickable(enabled = tienePermisoParaEditar && user.rolProgramado == null && !hayPeticionPendiente) { showMenu = true }
                    ) {
                        Column(modifier = Modifier.padding(16.dp)) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                // Nombre con weight + elipsis: nombres largos NO empujan el badge de rol fuera de pantalla.
                                Text(
                                    user.nombre.uppercase(),
                                    fontWeight = FontWeight.Black, color = Color.DarkGray,
                                    style = MaterialTheme.typography.titleMedium,
                                    maxLines = 2, overflow = TextOverflow.Ellipsis,
                                    modifier = Modifier.weight(1f)
                                )
                                Spacer(modifier = Modifier.width(8.dp))
                                val badgeText = if (hayPeticionPendiente) "STAND BY" else user.rol.replace("_", " ").uppercase()
                                val badgeColor = if (hayPeticionPendiente) Color.Red else SmartVanColors.AzulOscuro
                                Box(modifier = Modifier.background(badgeColor, RoundedCornerShape(8.dp)).padding(horizontal = 12.dp, vertical = 4.dp)) {
                                    Text(badgeText, color = Color.White, style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, maxLines = 1)
                                }
                                // Botón visible si tienes rango > que el usuario. Desarrollador
                                // (rango 120) puede tocar hasta master; admin_general no toca
                                // master ni desarrollador.
                                if (esAdminGeneral && user.rol != "desarrollador" &&
                                    (miRolActual == "desarrollador" || (user.rol != "admin_general" && user.rol != "master"))
                                ) {
                                    Spacer(modifier = Modifier.width(8.dp))
                                    Icon(
                                        Icons.Filled.Delete,
                                        contentDescription = "Eliminar cuenta",
                                        tint = Color.Red.copy(alpha = 0.6f),
                                        modifier = Modifier.size(20.dp).clickable { mostrarConfirmEliminar = user }
                                    )
                                }
                            }

                            // Reset password por jerarquía de rango: puedo resetear a cualquiera de rango
                            // MENOR al mío. desarrollador(120) > master(100) > admin_general(80)...
                            // Antes se excluía master siempre, así que el desarrollador no podía resetearlo.
                            val rangoDe = { r: String -> when (r) {
                                "desarrollador" -> 120; "master" -> 100; "admin_general" -> 80
                                "admin" -> 60; "chofer_admin" -> 40; "chofer" -> 30; else -> 10
                            } }
                            if (esAdminGeneral && rangoDe(miRolActual) > rangoDe(user.rol)) {
                                Spacer(modifier = Modifier.height(6.dp))
                                OutlinedButton(
                                    onClick = { viewModel.resetearContrasena(user.uid, user.nombre) },
                                    modifier = Modifier.fillMaxWidth().height(36.dp),
                                    shape = RoundedCornerShape(8.dp),
                                    colors = ButtonDefaults.outlinedButtonColors(contentColor = SmartVanColors.Naranja),
                                    border = androidx.compose.foundation.BorderStroke(1.dp, SmartVanColors.Naranja.copy(alpha = 0.5f)),
                                    contentPadding = PaddingValues(horizontal = 12.dp, vertical = 0.dp)
                                ) {
                                    Icon(Icons.Filled.Key, contentDescription = null, modifier = Modifier.size(15.dp), tint = SmartVanColors.Naranja)
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text("Restablecer Contraseña", fontSize = 12.sp, fontWeight = FontWeight.SemiBold)
                                }
                            }

                            Spacer(modifier = Modifier.height(4.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(Icons.Filled.Email, contentDescription = null, modifier = Modifier.size(16.dp), tint = Color.Gray)
                                Spacer(modifier = Modifier.width(4.dp))
                                Text(user.correo, style = MaterialTheme.typography.bodyMedium, color = Color.Gray)
                            }

                            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Key, contentDescription = null, modifier = Modifier.size(14.dp), tint = Color.LightGray)
                                    Spacer(modifier = Modifier.width(4.dp))
                                    Text("ID: ${user.uid.take(8)}...", style = MaterialTheme.typography.bodySmall, color = Color.LightGray)
                                }
                                if (tienePermisoParaEditar && user.rolProgramado == null && !hayPeticionPendiente) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Text("Toca para editar", style = MaterialTheme.typography.labelSmall, color = Color(0xFF41B6E6))
                                        Spacer(modifier = Modifier.width(4.dp))
                                        Icon(Icons.Filled.Edit, contentDescription = null, modifier = Modifier.size(14.dp), tint = Color(0xFF41B6E6))
                                    }
                                }
                            }

                            if (hayPeticionPendiente) {
                                Row(modifier = Modifier.padding(top = 8.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Warning, contentDescription = null, tint = Color.Red, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(4.dp))
                                    Text("Petición a ${user.rolSolicitado?.uppercase()} pendiente de aprobar", color = Color.Red, style = MaterialTheme.typography.bodySmall, fontWeight = FontWeight.Bold)
                                }
                            }

                            if (user.rolProgramado != null) {
                                Row(modifier = Modifier.padding(top = 8.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Schedule, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(4.dp))
                                    Text("Cambio a ${user.rolProgramado.uppercase()} pendiente", color = SmartVanColors.Naranja, style = MaterialTheme.typography.bodySmall, fontWeight = FontWeight.Bold)
                                    Spacer(modifier = Modifier.width(8.dp))
                                    TextButton(onClick = { scope.launch { viewModel.forzarCambioPendiente(user.uid, user.rolProgramado!!) } }) {
                                        Text("Ejecutar ahora", fontSize = 11.sp, color = SmartVanColors.Verde)
                                    }
                                }
                            }

                            if (esAdminGeneral && hayPeticionPendiente) {
                                Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp)) {
                                    Button(onClick = { viewModel.confirmarCambio(user.uid, user.rolSolicitado!!) }, colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde)) { Text("Aprobar") }
                                    Spacer(modifier = Modifier.width(8.dp))
                                    Button(onClick = { viewModel.cancelarCambio(user.uid) }, colors = ButtonDefaults.buttonColors(containerColor = Color.Red)) { Text("Declinar") }
                                }
                            }

                            DropdownMenu(expanded = showMenu, onDismissRequest = { showMenu = false }) {
                                opcionesDeRol.forEach { nuevoRol ->
                                    DropdownMenuItem(
                                        text = { Text("Hacer ${nuevoRol.uppercase()}") },
                                        onClick = { showMenu = false; rolAConfirmar = nuevoRol }
                                    )
                                }
                            }

                            if (rolAConfirmar != null) {
                                AlertDialog(
                                    onDismissRequest = { rolAConfirmar = null },
                                    title = { Text("Confirmar cambio de rol", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro) },
                                    text = { Text("Vas a cambiar el rol de ${user.nombre.uppercase()} a ${rolAConfirmar!!.uppercase()}. Esta acción es inmediata.") },
                                    confirmButton = {
                                        Button(onClick = { viewModel.cambiarRol(user.uid, rolAConfirmar!!, miRolActual); rolAConfirmar = null }, colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)) { Text("Confirmar") }
                                    },
                                    dismissButton = { TextButton(onClick = { rolAConfirmar = null }) { Text("Cancelar") } }
                                )
                            }
                        }
                    }
                }
            }
        }

        var viajesPendientes by remember { mutableStateOf(0) }
        var mostrarReasignar by remember { mutableStateOf(false) }
        var choferReemplazo by remember { mutableStateOf("") }

        mostrarConfirmEliminar?.let { userEliminar ->
            if (!mostrarReasignar) {
                AlertDialog(
                    onDismissRequest = { mostrarConfirmEliminar = null; viajesPendientes = 0 },
                    title = { Text("Eliminar cuenta", fontWeight = FontWeight.Black, color = Color.Red) },
                    text = {
                        Column {
                            Text("Vas a eliminar la cuenta de ${userEliminar.nombre.uppercase()} (${userEliminar.correo}). Esta acción no se puede deshacer.")
                            if (userEliminar.rol == "chofer") {
                                Spacer(modifier = Modifier.height(8.dp))
                                Text(
                                    "Este usuario es CHOFER. Se verificarán viajes pendientes antes de eliminar.",
                                    color = SmartVanColors.Naranja,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 13.sp
                                )
                            }
                        }
                    },
                    confirmButton = {
                        Button(
                            onClick = {
                                viewModel.verificarYEliminarCuenta(
                                    user = userEliminar,
                                    onTieneViajes = { cantidad ->
                                        viajesPendientes = cantidad
                                        mostrarReasignar = true
                                    },
                                    onEliminado = {
                                        mostrarConfirmEliminar = null
                                        viajesPendientes = 0
                                    }
                                )
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = Color.Red)
                        ) { Text("Eliminar") }
                    },
                    dismissButton = {
                        TextButton(onClick = { mostrarConfirmEliminar = null }) { Text("Cancelar") }
                    }
                )
            } else {
                AlertDialog(
                    onDismissRequest = { mostrarReasignar = false; mostrarConfirmEliminar = null },
                    title = {
                        Text(
                            "Reasignación obligatoria",
                            fontWeight = FontWeight.Black,
                            color = SmartVanColors.Naranja
                        )
                    },
                    text = {
                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            Text(
                                "${userEliminar.nombre.uppercase()} tiene $viajesPendientes viaje(s) futuros programados. Debes reasignarlos antes de eliminar la cuenta.",
                                fontWeight = FontWeight.Bold
                            )
                            Spacer(modifier = Modifier.height(4.dp))
                            Text("Selecciona el chofer de reemplazo:", fontSize = 14.sp)

                            val choferesDisponibles = usuarios
                                .filter { it.rol == "chofer" && it.uid != userEliminar.uid }
                                .map { it.nombre }

                            if (choferesDisponibles.isEmpty()) {
                                Text(
                                    "No hay otros choferes disponibles. Primero asigna el rol de chofer a otro usuario.",
                                    color = Color.Red,
                                    fontSize = 13.sp
                                )
                            } else {
                                choferesDisponibles.forEach { nombre ->
                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .clickable { choferReemplazo = nombre }
                                            .background(
                                                if (choferReemplazo == nombre) Color(0xFFE3F2FD) else Color.Transparent,
                                                RoundedCornerShape(8.dp)
                                            )
                                            .padding(12.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        RadioButton(
                                            selected = choferReemplazo == nombre,
                                            onClick = { choferReemplazo = nombre }
                                        )
                                        Spacer(modifier = Modifier.width(8.dp))
                                        Text(nombre, fontWeight = if (choferReemplazo == nombre) FontWeight.Bold else FontWeight.Normal)
                                    }
                                }
                            }
                        }
                    },
                    confirmButton = {
                        Button(
                            onClick = {
                                if (choferReemplazo.isNotBlank()) {
                                    viewModel.reasignarYEliminarChofer(userEliminar, choferReemplazo)
                                    mostrarReasignar = false
                                    mostrarConfirmEliminar = null
                                    choferReemplazo = ""
                                    viajesPendientes = 0
                                }
                            },
                            enabled = choferReemplazo.isNotBlank(),
                            colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)
                        ) { Text("Reasignar y Eliminar") }
                    },
                    dismissButton = {
                        TextButton(onClick = {
                            mostrarReasignar = false
                            mostrarConfirmEliminar = null
                            choferReemplazo = ""
                        }) { Text("Cancelar") }
                    }
                )
            }
        }
    }
}

@Composable
fun AdminSeatItem(seat: AdminSeatInfo, onClick: () -> Unit) {
    val backgroundColor = when (seat.status) {
        AdminSeatStatus.LIBRE -> SmartVanColors.Verde
        AdminSeatStatus.PAGADO -> Color(0xFFBDBDBD)
        AdminSeatStatus.CONGELADO -> SmartVanColors.Amarillo
    }
    val textColor = when (seat.status) {
        AdminSeatStatus.LIBRE -> Color.White
        AdminSeatStatus.PAGADO -> Color.DarkGray
        AdminSeatStatus.CONGELADO -> Color(0xFF5D4037)
    }
    Column(
        modifier = Modifier.clickable(onClick = onClick),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(modifier = Modifier.width(40.dp).height(8.dp).background(backgroundColor, RoundedCornerShape(topStart = 8.dp, topEnd = 8.dp)))
        Box(modifier = Modifier.size(58.dp).background(backgroundColor, RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(seat.asiento.toString(), color = textColor, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
                if (seat.status == AdminSeatStatus.CONGELADO) {
                    // Icon en vez de emoji ⏳: el reloj de arena no se dibuja en Compose Web.
                    Icon(Icons.Filled.Schedule, contentDescription = "En proceso", tint = textColor, modifier = Modifier.size(14.dp))
                }
            }
        }
    }
}




@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ConflictoAsientoCard(
    conflicto: ConflictoAsiento,
    asientosLibresDelViaje: List<Int>,
    onReasignar: (asientoViejo: Int, asientoNuevo: Int, pasajero: PasajeroInfo) -> Unit,
    onReembolsar: () -> Unit
) {
    var mostrarDialogoReasignar by remember { mutableStateOf(false) }
    var pasajeroAReasignar by remember { mutableStateOf<PasajeroInfo?>(null) }
    var asientoViejoSeleccionado by remember { mutableStateOf(0) }
    var asientoNuevoSeleccionado by remember { mutableStateOf(0) }
    var expandedAsiento by remember { mutableStateOf(false) }
    var mostrarConfirmReembolso by remember { mutableStateOf(false) }

    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        border = BorderStroke(1.dp, SmartVanColors.NaranjaDark.copy(alpha = 0.5f)),
        shape = RoundedCornerShape(10.dp),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(modifier = Modifier.padding(12.dp)) {
            // Header
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(conflicto.metodoPago.uppercase(), fontWeight = FontWeight.Bold, color = SmartVanColors.NaranjaDeep, fontSize = 11.sp,
                    modifier = Modifier.background(SmartVanColors.FondoNaranja, RoundedCornerShape(20.dp)).padding(horizontal = 8.dp, vertical = 2.dp))
                Spacer(modifier = Modifier.width(8.dp))
                Text("$${conflicto.montoTotal} MXN", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
                Spacer(modifier = Modifier.weight(1f))
                Text("Pendiente: $${conflicto.montoPendiente}", color = Color.Red, fontWeight = FontWeight.Bold, fontSize = 11.sp)
            }
            if (conflicto.email.isNotBlank()) {
                Text(conflicto.email, color = Color.Gray, style = MaterialTheme.typography.bodySmall)
            }
            Spacer(modifier = Modifier.height(6.dp))

            // Asientos en conflicto
            conflicto.pasajerosEnConflicto.forEachIndexed { idx, pasajero ->
                val asientoConflicto = conflicto.asientosEnConflicto.getOrNull(idx) ?: 0
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoRojo),
                    shape = RoundedCornerShape(8.dp),
                    modifier = Modifier.fillMaxWidth().padding(vertical = 3.dp)
                ) {
                    Row(modifier = Modifier.padding(10.dp), verticalAlignment = Alignment.CenterVertically) {
                        Column(modifier = Modifier.weight(1f)) {
                            Text("Asiento $asientoConflicto — ${pasajero.nombre}", fontWeight = FontWeight.Bold, color = Color.Red, style = MaterialTheme.typography.bodySmall)
                            Text("Asiento ya vendido, requiere reasignación", color = Color(0xFF795548), fontSize = 10.sp)
                        }
                        Button(
                            onClick = {
                                pasajeroAReasignar = pasajero
                                asientoViejoSeleccionado = asientoConflicto
                                asientoNuevoSeleccionado = asientosLibresDelViaje.firstOrNull() ?: 0
                                mostrarDialogoReasignar = true
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                            shape = RoundedCornerShape(8.dp),
                            contentPadding = PaddingValues(horizontal = 12.dp, vertical = 6.dp),
                            enabled = asientosLibresDelViaje.isNotEmpty()
                        ) {
                            Text("Reasignar", fontSize = 11.sp)
                        }
                    }
                }
            }

            // Asientos ya asignados (info)
            if (conflicto.asientosAsignados.isNotEmpty()) {
                Spacer(modifier = Modifier.height(4.dp))
                Text("Asientos ${conflicto.asientosAsignados.joinToString(", ")} ya asignados", color = SmartVanColors.Verde, fontSize = 10.sp, fontWeight = FontWeight.Medium)
            }

            Spacer(modifier = Modifier.height(8.dp))
            // Botón reembolso como última opción
            OutlinedButton(
                onClick = { mostrarConfirmReembolso = true },
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(8.dp),
                colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red),
                border = BorderStroke(1.dp, Color.Red.copy(alpha = 0.3f))
            ) {
                Text("Procesar reembolso ($${conflicto.montoPendiente} MXN)", fontSize = 11.sp, color = Color.Red)
            }
        }
    }

    // Diálogo de reasignación
    if (mostrarDialogoReasignar && pasajeroAReasignar != null) {
        AlertDialog(
            onDismissRequest = { mostrarDialogoReasignar = false },
            title = {
                Text("Reasignar Asiento", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro)
            },
            text = {
                Column {
                    Text("${pasajeroAReasignar!!.nombre}", fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                    Text("Asiento original: $asientoViejoSeleccionado (ocupado)", color = Color.Red, style = MaterialTheme.typography.bodySmall)
                    Spacer(modifier = Modifier.height(12.dp))
                    Text("Selecciona nuevo asiento:", fontWeight = FontWeight.Medium)
                    Spacer(modifier = Modifier.height(6.dp))
                    ExposedDropdownMenuBox(expanded = expandedAsiento, onExpandedChange = { expandedAsiento = it }) {
                        OutlinedTextField(
                            value = if (asientoNuevoSeleccionado > 0) "Asiento $asientoNuevoSeleccionado" else "Seleccionar...",
                            onValueChange = {},
                            readOnly = true,
                            trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedAsiento) },
                            modifier = Modifier.menuAnchor().fillMaxWidth(),
                            shape = RoundedCornerShape(10.dp)
                        )
                        ExposedDropdownMenu(expanded = expandedAsiento, onDismissRequest = { expandedAsiento = false }) {
                            asientosLibresDelViaje.forEach { asiento ->
                                DropdownMenuItem(
                                    text = { Text("Asiento $asiento", color = SmartVanColors.Verde, fontWeight = FontWeight.Bold) },
                                    onClick = { asientoNuevoSeleccionado = asiento; expandedAsiento = false }
                                )
                            }
                        }
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        if (asientoNuevoSeleccionado > 0) {
                            onReasignar(asientoViejoSeleccionado, asientoNuevoSeleccionado, pasajeroAReasignar!!)
                            mostrarDialogoReasignar = false
                            asientoNuevoSeleccionado = 0
                            pasajeroAReasignar = null
                        }
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                    enabled = asientoNuevoSeleccionado > 0
                ) { Text("Confirmar Reasignación") }
            },
            dismissButton = {
                TextButton(onClick = { mostrarDialogoReasignar = false }) { Text("Cancelar") }
            }
        )
    }

    // Diálogo de confirmación de reembolso
    if (mostrarConfirmReembolso) {
        AlertDialog(
            onDismissRequest = { mostrarConfirmReembolso = false },
            title = { Text("Procesar Reembolso", fontWeight = FontWeight.Black, color = Color.Red) },
            text = {
                Column {
                    Text("¿Estás seguro de marcar este conflicto para reembolso?", color = Color.DarkGray)
                    Spacer(modifier = Modifier.height(8.dp))
                    Text("Monto a reembolsar: $${conflicto.montoPendiente} MXN", fontWeight = FontWeight.Bold, color = Color.Red)
                    Text("Método: ${conflicto.metodoPago.uppercase()}", color = Color.Gray, style = MaterialTheme.typography.bodySmall)
                    Spacer(modifier = Modifier.height(4.dp))
                    Text("El reembolso se procesará manualmente desde Stripe.", color = Color.Gray, fontSize = 10.sp, fontStyle = FontStyle.Italic)
                }
            },
            confirmButton = {
                Button(
                    onClick = { onReembolsar(); mostrarConfirmReembolso = false },
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Red)
                ) { Text("Confirmar Reembolso") }
            },
            dismissButton = {
                TextButton(onClick = { mostrarConfirmReembolso = false }) { Text("Cancelar") }
            }
        )
    }
}

@Composable
fun ReservaCard(reserva: ReservaAdmin, onReprogramarClick: () -> Unit, onCancelarClick: (ReservaAdmin) -> Unit, onReenviarClick: ((ReservaAdmin) -> Unit)? = null, onConfirmarPagoClick: ((ReservaAdmin) -> Unit)? = null) {
    val (bgColor, borderColor, iconColor, statusText) = when {
        reserva.esPasado -> listOf(SmartVanColors.FondoGrisClaro, Color.LightGray, Color.Gray, "FINALIZADO")
        reserva.viajeFueCancelado -> listOf(
            SmartVanColors.FondoRojo,
            Color.Red,
            Color.Red,
            "REQUIERE ATENCIÓN"
        )

        else -> listOf(Color(0xFFE8F5E9), SmartVanColors.Verde, SmartVanColors.Verde, "PROGRAMADO")
    }

    Card(
        colors = CardDefaults.cardColors(containerColor = bgColor as Color),
        border = BorderStroke(1.dp, borderColor as Color),
        modifier = Modifier.width(280.dp),
        shape = RoundedCornerShape(16.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.size(28.dp).background((iconColor as Color).copy(alpha = 0.15f), CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        val statusIcon = when {
                            reserva.esPasado -> Icons.Filled.Schedule
                            reserva.viajeFueCancelado -> Icons.Filled.Warning
                            else -> Icons.Filled.Email
                        }
                        Icon(statusIcon, contentDescription = null, tint = iconColor, modifier = Modifier.size(15.dp))
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        statusText.toString(),
                        style = MaterialTheme.typography.labelSmall,
                        fontWeight = FontWeight.Bold,
                        color = iconColor
                    )
                }
            }
            Spacer(modifier = Modifier.height(12.dp))
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Filled.Map, contentDescription = null, tint = SmartVanColors.AzulOscuro, modifier = Modifier.size(18.dp))
                Spacer(modifier = Modifier.width(6.dp))
                Text(
                    reserva.ruta.uppercase(),
                    fontWeight = FontWeight.Black,
                    color = SmartVanColors.AzulOscuro
                )
            }
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(top = 4.dp)) {
                Icon(Icons.Filled.CalendarToday, contentDescription = null, tint = Color.Gray, modifier = Modifier.size(14.dp))
                Spacer(modifier = Modifier.width(6.dp))
                Text(
                    "${reserva.fecha}  •  ${reserva.horario}",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color.DarkGray
                )
            }
            Spacer(modifier = Modifier.height(10.dp))
            HorizontalDivider(color = (borderColor as Color).copy(alpha = 0.5f))
            Spacer(modifier = Modifier.height(10.dp))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Filled.People, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(
                        "${reserva.asientosComprados} asiento(s)",
                        fontWeight = FontWeight.Bold,
                        color = Color.DarkGray,
                        fontSize = 13.sp
                    )
                }
                Box(
                    modifier = Modifier.background(SmartVanColors.Verde.copy(alpha = 0.1f), RoundedCornerShape(20.dp))
                        .padding(horizontal = 10.dp, vertical = 3.dp)
                ) {
                    Text(
                        "$${reserva.totalPagado} MXN",
                        fontWeight = FontWeight.Black,
                        color = SmartVanColors.Verde,
                        fontSize = 13.sp
                    )
                }
            }
            // Nombres de pasajeros
            if (reserva.pasajeros.isNotEmpty()) {
                Spacer(modifier = Modifier.height(8.dp))
                reserva.pasajeros.forEach { p ->
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(vertical = 2.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                            Icon(Icons.Filled.Person, contentDescription = null, tint = SmartVanColors.AzulOscuro, modifier = Modifier.size(14.dp))
                            Spacer(modifier = Modifier.width(4.dp))
                            Text(
                                "${p.nombre} — Asiento ${p.asiento}",
                                style = MaterialTheme.typography.bodySmall,
                                color = Color.DarkGray,
                                fontWeight = FontWeight.Medium,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                        // Botón descargar boleto individual
                        IconButton(
                            onClick = {
                                val boleto = Boleto(
                                    asientos = listOf(p.asiento),
                                    pasajeros = listOf(p),
                                    totalPagado = reserva.totalPagado / reserva.asientosComprados,
                                    fechaViaje = reserva.fecha,
                                    horario = reserva.horario,
                                    origenDestino = reserva.ruta,
                                    metodoPago = reserva.metodoPago,
                                    pagoConfirmado = reserva.pagoConfirmado,
                                    timestamp = reserva.idReserva
                                )
                                org.example.abigail.imprimirBoleto(p, boleto, reserva.totalPagado / reserva.asientosComprados)
                            },
                            modifier = Modifier.size(28.dp)
                        ) {
                            Icon(Icons.Filled.FileDownload, contentDescription = "Descargar boleto", tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                        }
                    }
                }
            }

            Spacer(modifier = Modifier.height(10.dp))

            // Badge de pago en efectivo pendiente
            if (reserva.metodoPago == "efectivo" && !reserva.pagoConfirmado) {
                Card(
                    colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoNaranja),
                    shape = RoundedCornerShape(8.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(modifier = Modifier.padding(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.HourglassEmpty, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(16.dp))
                        Spacer(modifier = Modifier.width(6.dp))
                        Text("EFECTIVO — Pago Pendiente", fontWeight = FontWeight.Bold, color = SmartVanColors.Naranja, fontSize = 12.sp)
                    }
                }
                Spacer(modifier = Modifier.height(4.dp))
            }
            if (reserva.metodoPago == "efectivo" && reserva.pagoConfirmado) {
                Card(
                    colors = CardDefaults.cardColors(containerColor = Color(0xFFE8F5E9)),
                    shape = RoundedCornerShape(8.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(modifier = Modifier.padding(8.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.CheckCircle, contentDescription = null, tint = SmartVanColors.Verde, modifier = Modifier.size(16.dp))
                        Spacer(modifier = Modifier.width(6.dp))
                        Text("EFECTIVO — Cobrado", fontWeight = FontWeight.Bold, color = SmartVanColors.Verde, fontSize = 12.sp)
                    }
                }
                Spacer(modifier = Modifier.height(4.dp))
            }

            // Botón confirmar pago en efectivo (con diálogo anti error de dedo).
            var mostrarConfirmarPago by remember { mutableStateOf(false) }
            if (onConfirmarPagoClick != null && reserva.metodoPago == "efectivo" && !reserva.pagoConfirmado && !reserva.esPasado) {
                Button(
                    onClick = { mostrarConfirmarPago = true },
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Icon(Icons.Filled.CheckCircle, contentDescription = null, tint = Color.White, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(6.dp))
                    Text("Confirmar Pago en Efectivo", color = Color.White, fontSize = 12.sp, fontWeight = FontWeight.Bold)
                }
                Spacer(modifier = Modifier.height(4.dp))
                if (mostrarConfirmarPago) {
                    AlertDialog(
                        onDismissRequest = { mostrarConfirmarPago = false },
                        icon = { Icon(Icons.Filled.CheckCircle, contentDescription = null, tint = SmartVanColors.Verde) },
                        title = { Text("Confirmar cobro en efectivo") },
                        text = {
                            Column {
                                val asientosStr = reserva.pasajeros.joinToString(", ") { it.asiento.toString() }
                                val nombresStr = reserva.pasajeros.joinToString(", ") { it.nombre.ifBlank { "—" } }
                                Text("Marcarás como PAGADO(S) el/los asiento(s) $asientosStr de $nombresStr.", style = MaterialTheme.typography.bodySmall)
                                Spacer(modifier = Modifier.height(6.dp))
                                Text("Confirma SOLO si ya se recibió el dinero. No se puede revertir.",
                                    style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                            }
                        },
                        confirmButton = {
                            Button(
                                onClick = { mostrarConfirmarPago = false; onConfirmarPagoClick(reserva) },
                                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde)
                            ) { Text("Sí, cobrado") }
                        },
                        dismissButton = {
                            TextButton(onClick = { mostrarConfirmarPago = false }) { Text("Cancelar", color = Color.Gray) }
                        }
                    )
                }
            }

            // Botón reenviar boletos — disponible para cualquier reserva con pasajeros
            if (onReenviarClick != null && reserva.pasajeros.isNotEmpty()) {
                OutlinedButton(
                    onClick = { onReenviarClick(reserva) },
                    modifier = Modifier.fillMaxWidth(),
                    border = BorderStroke(1.dp, SmartVanColors.CyanAccent)
                ) {
                    Icon(Icons.Filled.Email, contentDescription = null, tint = SmartVanColors.CyanAccent, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(6.dp))
                    Text("Reenviar Boletos", color = SmartVanColors.CyanAccent, fontSize = 12.sp)
                }
                Spacer(modifier = Modifier.height(4.dp))
            }

            if (!reserva.esPasado) {
                if (reserva.viajeFueCancelado) {
                    Text(
                        "Este viaje fue cancelado. Contacta al cliente para gestionar el reembolso manualmente.",
                        style = MaterialTheme.typography.bodySmall,
                        color = Color.Red,
                        fontWeight = FontWeight.Medium,
                        modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp)
                    )
                } else {
                    OutlinedButton(
                        onClick = onReprogramarClick,
                        modifier = Modifier.fillMaxWidth(),
                        border = BorderStroke(1.dp, SmartVanColors.AzulOscuro)
                    ) {
                        Text("Reprogramar Asientos", color = SmartVanColors.AzulOscuro)
                    }
                    var mostrarConfirmCancelar by remember { mutableStateOf(false) }

                    OutlinedButton(
                        onClick = { mostrarConfirmCancelar = true },
                        shape = RoundedCornerShape(8.dp),
                        colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.Red)
                    ) {
                        Icon(Icons.Filled.Cancel, contentDescription = null, modifier = Modifier.size(16.dp))
                        Spacer(modifier = Modifier.width(4.dp))
                        Text("Cancelar", fontSize = 12.sp)
                    }

                    if (mostrarConfirmCancelar) {
                        AlertDialog(
                            onDismissRequest = { mostrarConfirmCancelar = false },
                            title = { Text("Cancelar Boleto", fontWeight = FontWeight.Black, color = Color.Red) },
                            text = {
                                Column {
                                    Text("Vas a cancelar esta reserva. Se liberarán los asientos y se registrará para reembolso.")
                                    Spacer(modifier = Modifier.height(8.dp))
                                    Text("Ruta: ${reserva.ruta}", fontWeight = FontWeight.Bold)
                                    Text("Fecha: ${reserva.fecha} - ${reserva.horario}")
                                    Text("Pasajeros: ${reserva.asientosComprados}", fontWeight = FontWeight.Medium)
                                    if (reserva.pasajeros.isNotEmpty()) {
                                        reserva.pasajeros.forEach { p ->
                                            Text("  • ${p.nombre} — Asiento ${p.asiento}", style = MaterialTheme.typography.bodySmall, color = Color.DarkGray)
                                        }
                                    }
                                    Spacer(modifier = Modifier.height(4.dp))
                                    Text("Total a reembolsar: $${reserva.totalPagado} MXN", color = Color.Red, fontWeight = FontWeight.Bold)
                                }
                            },
                            confirmButton = {
                                Button(
                                    onClick = {
                                        onCancelarClick(reserva)
                                        mostrarConfirmCancelar = false
                                    },
                                    colors = ButtonDefaults.buttonColors(containerColor = Color.Red)
                                ) { Text("Confirmar Cancelación") }
                            },
                            dismissButton = {
                                TextButton(onClick = { mostrarConfirmCancelar = false }) { Text("No cancelar") }
                            }
                        )
                    }

                }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DialogoReprogramacion(reservaOriginal: ReservaAdmin, ciudades: List<String>, viewModel: AdminViewModel, onVerAsientos: (String, String, String) -> Unit, onCancelar: () -> Unit) {
    val partesRuta = reservaOriginal.ruta.split("-")
    var origen by remember { mutableStateOf(partesRuta.getOrNull(0) ?: "") }
    var destino by remember { mutableStateOf(partesRuta.getOrNull(1) ?: "") }
    var fechaSeleccionada by remember { mutableStateOf(reservaOriginal.fecha) }
    var horarioSeleccionado by remember { mutableStateOf("") }

    var horariosDisponibles by remember { mutableStateOf<List<String>>(emptyList()) }
    var buscandoHorarios by remember { mutableStateOf(false) }

    var mostrarMenuOrigen by remember { mutableStateOf(false) }
    var mostrarMenuDestino by remember { mutableStateOf(false) }
    var mostrarCalendario by remember { mutableStateOf(false) }
    var mostrarMenuHorarios by remember { mutableStateOf(false) }

    val datePickerState =
        rememberDatePickerState(initialDisplayMode = androidx.compose.material3.DisplayMode.Picker)

    LaunchedEffect(origen, destino, fechaSeleccionada) {
        if (origen.isNotEmpty() && destino.isNotEmpty() && fechaSeleccionada.isNotEmpty()) {
            buscandoHorarios = true
            val rutaArmada = "$origen - $destino"

            horariosDisponibles =
                viewModel.obtenerHorariosParaFecha(rutaArmada, fechaSeleccionada)
            buscandoHorarios = false

            horarioSeleccionado =
                if (horariosDisponibles.contains(reservaOriginal.horario) && rutaArmada == reservaOriginal.ruta && fechaSeleccionada == reservaOriginal.fecha) {
                    reservaOriginal.horario
                } else {
                    horariosDisponibles.firstOrNull() ?: ""
                }
        }
    }

    AlertDialog(
        onDismissRequest = onCancelar,
        title = { Text("Reprogramación Segura", fontWeight = FontWeight.Black) },
        text = {
            Column(modifier = Modifier.fillMaxWidth()) {
                Text(
                    "Selecciona la nueva ruta y fecha. El sistema buscará los viajes programados automáticamente.",
                    color = Color.Gray,
                    style = MaterialTheme.typography.bodySmall
                )
                Spacer(modifier = Modifier.height(16.dp))

                ExposedDropdownMenuBox(
                    expanded = mostrarMenuOrigen,
                    onExpandedChange = { mostrarMenuOrigen = it },
                    modifier = Modifier.fillMaxWidth()
                ) {
                    OutlinedTextField(
                        value = origen.ifEmpty { "Seleccionar..." },
                        onValueChange = {}, readOnly = true,
                        label = { Text("Origen") },
                        modifier = Modifier.fillMaxWidth().menuAnchor(),
                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = mostrarMenuOrigen) }
                    )
                    ExposedDropdownMenu(expanded = mostrarMenuOrigen, onDismissRequest = { mostrarMenuOrigen = false }) {
                        ciudades.forEach { ciudad ->
                            DropdownMenuItem(
                                text = { Text(ciudad, fontWeight = FontWeight.Medium) },
                                onClick = { origen = ciudad; mostrarMenuOrigen = false },
                                contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding
                            )
                        }
                    }
                }
                Spacer(modifier = Modifier.height(8.dp))

                ExposedDropdownMenuBox(
                    expanded = mostrarMenuDestino,
                    onExpandedChange = { mostrarMenuDestino = it },
                    modifier = Modifier.fillMaxWidth()
                ) {
                    OutlinedTextField(
                        value = destino.ifEmpty { "Seleccionar..." },
                        onValueChange = {}, readOnly = true,
                        label = { Text("Destino") },
                        modifier = Modifier.fillMaxWidth().menuAnchor(),
                        trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = mostrarMenuDestino) }
                    )
                    ExposedDropdownMenu(expanded = mostrarMenuDestino, onDismissRequest = { mostrarMenuDestino = false }) {
                        ciudades.forEach { ciudad ->
                            DropdownMenuItem(
                                text = { Text(ciudad, fontWeight = FontWeight.Medium) },
                                onClick = { destino = ciudad; mostrarMenuDestino = false },
                                contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding
                            )
                        }
                    }
                }
                Spacer(modifier = Modifier.height(12.dp))

                Button(
                    onClick = { mostrarCalendario = true },
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)
                ) {
                    Text("Fecha: $fechaSeleccionada")
                }
                Spacer(modifier = Modifier.height(12.dp))

                if (buscandoHorarios) {
                    Text(
                        "Buscando viajes...",
                        color = Color.Gray,
                        fontStyle = FontStyle.Italic
                    )
                } else if (horariosDisponibles.isEmpty()) {
                    Text(
                        "No hay viajes programados para esta ruta y fecha.",
                        color = Color.Red,
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.bodySmall
                    )
                } else {
                    ExposedDropdownMenuBox(
                        expanded = mostrarMenuHorarios,
                        onExpandedChange = { mostrarMenuHorarios = it },
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        OutlinedTextField(
                            value = horarioSeleccionado.ifEmpty { "Seleccionar horario..." },
                            onValueChange = {}, readOnly = true,
                            label = { Text("Horario") },
                            modifier = Modifier.fillMaxWidth().menuAnchor(),
                            trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = mostrarMenuHorarios) },
                            colors = OutlinedTextFieldDefaults.colors(
                                focusedBorderColor = SmartVanColors.Verde,
                                unfocusedBorderColor = if (horarioSeleccionado.isEmpty()) Color.LightGray else SmartVanColors.Verde
                            )
                        )
                        ExposedDropdownMenu(expanded = mostrarMenuHorarios, onDismissRequest = { mostrarMenuHorarios = false }) {
                            horariosDisponibles.forEach { hora ->
                                DropdownMenuItem(
                                    text = { Text(hora, fontWeight = FontWeight.Medium) },
                                    onClick = { horarioSeleccionado = hora; mostrarMenuHorarios = false },
                                    contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding
                                )
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    onVerAsientos(
                        "$origen - $destino",
                        fechaSeleccionada,
                        horarioSeleccionado
                    )
                },
                enabled = horarioSeleccionado.isNotEmpty(),
                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde)
            ) { Text("Ver Asientos Disponibles", fontWeight = FontWeight.Bold) }
        },
        dismissButton = {
            TextButton(onClick = onCancelar) { Text("Cancelar", color = Color.Red) }
        }
    )

    if (mostrarCalendario) {
        DatePickerDialog(
            onDismissRequest = { mostrarCalendario = false },
            confirmButton = {
                TextButton(onClick = {
                    datePickerState.selectedDateMillis?.let { millis ->
                        fechaSeleccionada = org.example.abigail.formatMillisToDate(millis)
                    }
                    mostrarCalendario = false
                }) { Text("Aceptar") }
            },
            dismissButton = {
                TextButton(onClick = {
                    mostrarCalendario = false
                }) { Text("Cancelar") }
            }
        ) {
            DatePicker(state = datePickerState, showModeToggle = false)
        }
    }
}

@Composable
fun DialogoSeleccionPasajeros(pasajeros: List<PasajeroInfo>, onConfirmar: (List<PasajeroInfo>) -> Unit, onCancelar: () -> Unit) {
    var seleccionados by remember { mutableStateOf(pasajeros) }

    AlertDialog(
        onDismissRequest = onCancelar,
        title = { Text("Dividir Grupo", fontWeight = FontWeight.Black, color = SmartVanColors.AzulOscuro) },
        text = {
            Column(modifier = Modifier.fillMaxWidth()) {
                Text("Esta reserva tiene varios pasajeros. ¿A quiénes deseas reprogramar para el nuevo viaje?", color = Color.Gray, style = MaterialTheme.typography.bodySmall)
                Spacer(modifier = Modifier.height(16.dp))

                pasajeros.forEach { pasajero ->
                    val estaSeleccionado = seleccionados.contains(pasajero)
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable {
                                seleccionados = if (estaSeleccionado) seleccionados - pasajero else seleccionados + pasajero
                            }
                            .padding(vertical = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Checkbox(
                            checked = estaSeleccionado,
                            onCheckedChange = { checked ->
                                seleccionados = if (checked) seleccionados + pasajero else seleccionados - pasajero
                            },
                            colors = CheckboxDefaults.colors(checkedColor = SmartVanColors.Verde)
                        )
                        Spacer(modifier = Modifier.width(8.dp))
                        Column {
                            Text(pasajero.nombre, fontWeight = FontWeight.Bold, color = Color.DarkGray)
                            Text("Asiento Original: ${pasajero.asiento}", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(
                onClick = { onConfirmar(seleccionados) },
                enabled = seleccionados.isNotEmpty(),
                colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.AzulOscuro)
            ) { Text("Continuar") }
        },
        dismissButton = {
            TextButton(onClick = onCancelar) { Text("Cancelar", color = Color.Red) }
        }
    )
}
@Composable
fun MapaAsientosReprogramacion(ruta: String, fecha: String, horario: String, asientosOcupados: List<Int>, asientosNecesarios: Int, capacidadVehiculo: Int = 13, viewModel: AdminViewModel, onConfirmarAsientos: (List<Int>) -> Unit, onCancelar: (List<Int>) -> Unit ) {
    var asientosSeleccionados by remember { mutableStateOf(listOf<Int>()) }
    var mostrarAlertaRobo by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    val mostrarTemporizador by viewModel.mostrarTemporizador.collectAsState()
    val tiempoRestanteMilis by viewModel.tiempoRestanteMilis.collectAsState()

    LaunchedEffect(asientosSeleccionados.isNotEmpty()) {
        if (asientosSeleccionados.isNotEmpty()) {
            delay(15 * 60 * 1000L)
            asientosSeleccionados.forEach {
                viewModel.liberarAsiento(ruta, fecha, horario, it)
            }
            asientosSeleccionados = emptyList()
        }
    }

    AlertDialog(
        onDismissRequest = { onCancelar(asientosSeleccionados) },
        title = { Text("Elige los Nuevos Asientos", fontWeight = FontWeight.Black) },
        text = {
            Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {

                if (mostrarTemporizador) {
                    val minutos = (tiempoRestanteMilis / 1000) / 60
                    val segundos = (tiempoRestanteMilis / 1000) % 60

                    Row(
                        modifier = Modifier.fillMaxWidth().padding(8.dp),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(Icons.Default.Timer, contentDescription = null, tint = Color.Red)
                        Spacer(Modifier.width(8.dp))
                        Text(
                            text = "Tiempo para completar: ${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}",
                            color = Color.Red,
                            fontWeight = FontWeight.Bold
                        )
                    }
                }

                if (mostrarAlertaRobo) {
                    Text("Alguien más seleccionó este asiento en este instante.", color = Color.Red, fontSize = 12.sp)
                }

                LazyVerticalGrid(
                    columns = GridCells.Fixed(3),
                    modifier = Modifier.height(300.dp),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp),
                ) {
                    items(capacidadVehiculo) { index ->
                        val numeroAsiento = index + 1
                        val estaOcupado = asientosOcupados.contains(numeroAsiento)
                        val estaSeleccionado = asientosSeleccionados.contains(numeroAsiento)

                        val colorFondo = when {
                            estaOcupado -> Color.LightGray
                            estaSeleccionado -> SmartVanColors.Verde
                            else -> Color.White
                        }

                        Card(
                            modifier = Modifier
                                .height(50.dp)
                                .clickable(enabled = !estaOcupado) {
                                    scope.launch {
                                        mostrarAlertaRobo = false
                                        if (estaSeleccionado) {
                                            viewModel.liberarAsiento(ruta, fecha, horario, numeroAsiento)
                                            asientosSeleccionados = asientosSeleccionados - numeroAsiento
                                        } else if (asientosSeleccionados.size < asientosNecesarios) {
                                            val loLogramos = viewModel.intentarSeleccionar(ruta, fecha, horario, numeroAsiento)
                                            if (loLogramos) {
                                                asientosSeleccionados = asientosSeleccionados + numeroAsiento
                                            } else {
                                                mostrarAlertaRobo = true
                                            }
                                        }
                                    }
                                },
                            colors = CardDefaults.cardColors(containerColor = colorFondo),
                            border = BorderStroke(1.dp, if (estaOcupado) Color.Transparent else SmartVanColors.AzulOscuro)
                        ) {
                            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                                Text(numeroAsiento.toString(), color = if (estaSeleccionado || estaOcupado) Color.White else SmartVanColors.AzulOscuro, fontWeight = FontWeight.Bold)
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(
                enabled = asientosSeleccionados.size == asientosNecesarios,
                onClick = { onConfirmarAsientos(asientosSeleccionados) },
            ) { Text("Confirmar Cambio") }
        },
        dismissButton = {
            TextButton(onClick = { onCancelar(asientosSeleccionados) }) { Text("Regresar") }
        }
    )
}




/** Color de la etiqueta según el tipo de día, para distinguirlos de un vistazo. */
private fun colorTipoDia(dias: String): Color = when (TipoDia.normalizar(dias)) {
    TipoDia.SEMANA -> SmartVanColors.Azul
    TipoDia.SABADO -> SmartVanColors.Naranja
    else -> Color.Gray
}

/** Etiqueta compacta "L-V" / "Sáb" / "Todos" que acompaña al nombre del punto. */
@Composable
fun EtiquetaDias(dias: String, modifier: Modifier = Modifier) {
    val color = colorTipoDia(dias)
    Box(
        modifier = modifier
            .background(color.copy(alpha = 0.12f), RoundedCornerShape(6.dp))
            .padding(horizontal = 6.dp, vertical = 2.dp)
    ) {
        Text(TipoDia.etiquetaCorta(dias), fontSize = 10.sp, fontWeight = FontWeight.Bold, color = color)
    }
}

/**
 * Selector de días de servicio. El mismo lugar puede tener una corrida entre semana
 * y otra en sábado con horas distintas: esta etiqueta es la que separa una de otra
 * al momento de programar el viaje.
 */
@Composable
fun SelectorDiasServicio(dias: String, onDiasChange: (String) -> Unit) {
    Text("Días en que opera este punto:", fontWeight = FontWeight.SemiBold, color = SmartVanColors.AzulOscuro, fontSize = 13.sp)
    Row(horizontalArrangement = Arrangement.spacedBy(6.dp), modifier = Modifier.fillMaxWidth()) {
        TipoDia.OPCIONES.forEach { opcion ->
            val seleccionado = TipoDia.normalizar(dias) == opcion
            val color = colorTipoDia(opcion)
            Card(
                modifier = Modifier.weight(1f).clickable { onDiasChange(opcion) },
                colors = CardDefaults.cardColors(containerColor = if (seleccionado) color else Color(0xFFF3F4F6)),
                shape = RoundedCornerShape(8.dp)
            ) {
                Text(
                    TipoDia.etiqueta(opcion),
                    modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp, horizontal = 4.dp),
                    textAlign = TextAlign.Center,
                    fontSize = 11.sp,
                    fontWeight = if (seleccionado) FontWeight.Bold else FontWeight.Normal,
                    color = if (seleccionado) Color.White else SmartVanColors.AzulOscuro
                )
            }
        }
    }
}
